<template>
  <form id="frm_action" :key="componentKey">
    <ConfirmDialog />
    <div class="row p-col-12 group-button-detail-top" v-if="mode=='view'">
      <Button
          v-for="lad in list_action_detail"
          :key="lad.code_change"
          :label="lad.action"
          class="style-button-common  mt-lg-0 mt-2"
          :class="lad.class_button"
          @click="click_change_status(lad.code_change)"
      />
    </div>

    <div class="p-formgrid">
      <div class="col-6">
        <div class="p-card-field">
          <label class="p-col-fixed txt-right txt-required txt_style_lable"
          >Status</label
          >
          <div class="p-col">
            <v-select
                :disabled="core_disable('booking_status')"
                class=""
                placeholder="Choose"
                v-model="obj_data.booking_status"
                :options="listStatus"
                :reduce="(item) => item.id"
                label="name"
            >
              <span slot="no-options" @click="$refs.select.open = false">
                Empty data
              </span>
            </v-select>
            <input class="input_tmp_validator" id="tmp_booking_status"/>
          </div>
        </div>

        <div
            class="p-card-field"
            v-if="core_display_view('group_created_at_post_id')"
        >
          <div class="row">
            <div class="col-6">
              <label class="p-col-fixed txt-right txt-required txt_style_lable"
              >Created date</label
              >
              <div class="p-col">
                <Calendar
                    :disabled="core_disable('created_at')"
                    :showOnFocus="false"
                    dateFormat="dd/mm/yy"
                    id="end_booking_date"
                    :showIcon="true"
                    appendTo="body"
                    :showClear="true"
                    :manualInput="true"
                    v-model="obj_data.created_at"
                    placeholder="Choose"
                    :showTime="true"
                    :showSeconds="false"
                    @clear-click="change_rent_pick_up_date($event)"
                    @date-select="change_rent_pick_up_date($event)"
                />
              </div>
            </div>

            <div class="col-6">
              <label class="p-col-fixed txt-right txt-required txt_style_lable"
              >Post ID</label
              >
              <div class="p-col">
                <div class="class_style_input_a" style="">
                  <a v-if="obj_data.rent_available_id" class="style_tag_a" :href="'/admin/list-available_for_rent/edit/'+obj_data.rent_available_id">{{obj_data.post_id}}</a>
                </div>
                <!-- <InputText
                    :disabled="core_disable('post_id')"
                    type="text"
                    class="class_style_input_a"
                    v-model="obj_data.post_id"
                    placeholder="Input"
                /> -->
              </div>
            </div>
          </div>
        </div>

        <div class="p-card-field" style="margin-top: 8px; margin-bottom: 8px">
          <label class="p-col-fixed txt-right style_title_group txt_style_lable"
          >RENTAL INFORMATION</label
          >
          <!--          <div class="p-col">
          </div>-->
        </div>

        <div class="p-card-field" v-if="core_display_view('rent_available_id')">
          <label class="p-col-fixed txt-right txt_style_lable">Post ID</label>
          <div class="p-col">
            <v-select
                :clearable="false"
                class=""
                @search="Search_available_for_rent"
                placeholder="Choose"
                v-model="obj_data.rent_available_id"
                :options="list_available_for_rent"
                :reduce="(item) => item.id"
                label="code"
                @input="change_list_available_for_rent"
            >
              <span slot="no-options" @click="$refs.select.open = false">
                Empty data
              </span>
            </v-select>
          </div>
        </div>
        <div class="p-card-field">
          <label class="p-col-fixed txt-right txt-required txt_style_lable"
          >Vehicle category</label
          >
          <div class="p-col">
            <v-select
                :disabled="core_disable('rent_vehicle_category_id')"
                :key="key_vehicle_category"
                :clearable="false"
                class=""
                @search="SearchVehicleCategory"
                placeholder="Choose"
                v-model="obj_data.rent_vehicle_category_id"
                :options="list_vehicle_category_id"
                :reduce="(item) => item.id"
                label="name"
                @input="change_list_vehicle_category"
            >
              <span slot="no-options" @click="$refs.select.open = false">
                Empty data
              </span>
            </v-select>
            <input
                class="input_tmp_validator"
                id="tmp_rent_vehicle_category_id"
            />
          </div>
        </div>
        <div
            class="p-card-field div_check"
            v-if="core_display_view('is_allow_car_category')"
        >
          <div class="p-col checkbox">
            <Checkbox
                v-model="obj_data.is_allow_car_category"
                :binary="true"
                @change="change_allow_car_category"
            />
            <label class="p-col-fixed txt-right text"
            >Allow to choose a car from other category.</label
            >
          </div>
        </div>

        <div
            class="p-card-field"
            v-if="core_display_view('group_car_forrent_id')"
        >
          <div class="row">
            <div class="col-6">
              <label class="p-col-fixed txt-right txt-required txt_style_lable"
              >License plate number</label
              >
              <div class="p-col">
                 <InputText
                  v-if="!$commonFuction.isEmpty(obj_data.booking_status) &&   (obj_data.booking_status == this.$constants.STATUS_ORDER.COMPLETED_RENT || obj_data.booking_status == this.$constants.STATUS_ORDER.CANCEL_RENT) "
                    :disabled="true"
                    type="text"
                    class=""
                    v-model="obj_data.rent_license_plate_number"
                    placeholder="Input"
                />
                <v-select
                    v-else
                    :disabled="core_disable('rent_car_for_rent_id')"
                    :key="key_car_for_rent"
                    :clearable="false"
                    class=""
                    @search="SearchCarForRent"
                    placeholder="Choose"
                    v-model="obj_data.rent_car_for_rent_id"
                    :options="list_car_for_rent_id"
                    :reduce="(item) => item.id"
                    label="license_plate_number"
                    @input="change_car_for_rent"
                >
                  <span slot="no-options" @click="$refs.select.open = false">
                    Empty data
                  </span>
                </v-select>
                <input
                    class="input_tmp_validator"
                    id="tmp_rent_car_for_rent_id"
                />
              </div>
            </div>

            <div class="col-6">
              <label class="p-col-fixed txt-right txt-required txt_style_lable"
              >Car’s color</label
              >
              <div class="p-col">
                <InputText
                v-if="obj_data.car_for_rent && !$commonFuction.isEmpty(obj_data.booking_status) &&   (obj_data.booking_status == this.$constants.STATUS_ORDER.COMPLETED_RENT || obj_data.booking_status == this.$constants.STATUS_ORDER.CANCEL_RENT) "
                    :disabled="core_disable('color_car_forent')"
                    type="text"
                    class=""
                    v-model="obj_data.car_for_rent.color"
                    placeholder="Input"
                />
                <InputText
                    v-else
                    :disabled="core_disable('color_car_forent')"
                    type="text"
                    class=""
                    v-model="obj_data.color_car_forent"
                    placeholder="Input"
                />
              </div>
            </div>
          </div>
        </div>
        <div class="p-card-field">
          <label class="p-col-fixed txt-right txt-required txt_style_lable"
          >Term</label
          >
          <div class="p-col">
            <v-select
                :disabled="core_disable('rent_term_id')"
                :key="key_term"
                :clearable="false"
                class=""
                @search="SearchTerm"
                placeholder="Choose"
                v-model="obj_data.rent_term_id"
                :options="list_term_id"
                :reduce="(item) => item.id"
                label="name"
                @input="change_list_term"
            >
              <span slot="no-options" @click="$refs.select.open = false">
                Empty data
              </span>
            </v-select>
            <input class="input_tmp_validator" id="tmp_rent_term_id"/>
          </div>
        </div>
        <div class="p-card-field">
          <div class="row">
            <div class="col-6">
              <label class="p-col-fixed txt-right txt-required txt_style_lable"
              >Pick-up date</label
              >
              <div class="p-col">
                <Calendar
                    :disabled="core_disable('rent_pick_up_date')"
                    :showOnFocus="false"
                    dateFormat="dd/mm/yy"
                    id="end_booking_date"
                    :showIcon="true"
                    appendTo="body"
                    :showClear="true"
                    :manualInput="false"
                    
                    v-model="obj_data.rent_pick_up_date"
                    placeholder="Choose"
                    :showTime="true"
                    :showSeconds="false"
                    @clear-click="change_rent_pick_up_date($event)"
                    @date-select="change_rent_pick_up_date($event)"
                />
                <!-- :minDate="today" -->
                <input class="input_tmp_validator" id="tmp_rent_pick_up_date"/>
              </div>
            </div>

            <div class="col-6">
              <label class="p-col-fixed txt-right txt-required txt_style_lable"
              >Valid until</label
              >
              <div class="p-col">
                <Calendar
                      :disabled="core_disable('rent_valid_until')"
                    :showOnFocus="false"
                    dateFormat="dd/mm/yy"
                    id="end_booking_date"
                    :showIcon="true"
                    appendTo="body"
                    :showClear="true"
                    :manualInput="false"
                    v-model="obj_data.rent_valid_until"
                    placeholder="Choose"
                    :showTime="true"
                    :showSeconds="false"
                />
                <input class="input_tmp_validator" id="tmp_rent_valid_until"/>
              </div>
            </div>


          </div>
          </div>


<div class="p-card-field" v-if="!$commonFuction.isEmpty(obj_data.booking_status) &&   !(obj_data.booking_status == this.$constants.STATUS_ORDER.BOOKED_RENT || obj_data.booking_status == this.$constants.STATUS_ORDER.CANCEL_RENT) ">
          <div class="row">
            <div class="col-6">
              <label class="p-col-fixed txt-right txt_style_lable"
              >Actual pick-up date</label
              >
              <div class="p-col">
                <Calendar
                    :disabled="true"
                    :showOnFocus="false"
                    dateFormat="dd/mm/yy"
                    id="end_booking_date"
                    :showIcon="true"
                    appendTo="body"
                    :showClear="true"
                    :manualInput="true"
                    v-model="obj_data.actual_pickup_date_convert"
                    placeholder="Choose"
                    :showTime="true"
                    :showSeconds="false"
                    @clear-click="change_rent_pick_up_date($event)"
                    @date-select="change_rent_pick_up_date($event)"
                />
              </div>
            </div>

            <div class="col-6">
              <label class="p-col-fixed txt-right txt-required txt_style_lable"
              >Return date</label
              >
              <div class="p-col">
                <Calendar
                      :disabled="true"
                    :showOnFocus="false"
                    dateFormat="dd/mm/yy"
                    id="end_booking_date"
                    :showIcon="true"
                    appendTo="body"
                    :showClear="true"
                    :manualInput="true"
                    v-model="obj_data.complete_date_convert"
                    placeholder="-"
                    :showTime="true"
                    :showSeconds="false"
                />
              </div>
            </div>

            
          </div>

        </div>
        <div class="p-card-field">
          <label class="p-col-fixed txt-right txt-required txt_style_lable"
          >Pick-up showroom</label
          >
          <div class="p-col">
            <v-select
                :disabled="core_disable('showroom_id')"
                :clearable="false"
                class=""
                @search="Search_showroom"
                placeholder="Choose"
                v-model="obj_data.showroom_id"
                :options="list_showroom_id"
                :reduce="(item) => item.id"
                label="name"
            >
              <span slot="no-options" @click="$refs.select.open = false">
                Empty data
              </span>
            </v-select>
            <input class="input_tmp_validator" id="tmp_showroom_id"/>
          </div>
        </div>

        <div class="p-card-field">
          <label class="p-col-fixed txt-right txt_style_lable"
          >Contract ID</label
          >
          <div class="p-col">
            <InputText
                :disabled="core_disable('contract_id')"
                maxlength="50"
                id="contract_id"
                type="text"
                class=""
                v-model="obj_data.contract_id"
                placeholder="Input"
            />
          </div>
        </div>
        <div class="p-card-field">
          <label class="p-col-fixed txt-right txt_style_lable">Note</label>
          <div class="p-col">
            <Textarea
                :disabled="core_disable('note')"
                id="note"
                maxLength="500"
                rows="2"
                cols="30"
                :autoResize="true"
                v-model="obj_data.note"
                placeholder="Input"
            />
            <!--            <InputText id="note" type="text" class="" v-model="obj_data.note"  placeholder="Input"/>-->
          </div>
        </div>
      </div>
      <div class="col-6"  v-if=" mode =='view' && (obj_data.booking_status == this.$constants.STATUS_ORDER.RENTING_RENT || obj_data.booking_status == this.$constants.STATUS_ORDER.CLOSING_RENT || obj_data.booking_status == this.$constants.STATUS_ORDER.COMPLETED_RENT)">
        <div class="p-card-field" style="margin-top: 8px; margin-bottom: 8px">
          <label class="p-col-fixed txt-right style_title_group txt_style_lable"
          >RENEWAL INFORMATION</label
          >
          <!--          <div class="p-col">
          </div>-->
        </div>
      </div>
      <div class="col-12 row style-box-rewal"  v-if="mode =='view' && (obj_data.booking_status == this.$constants.STATUS_ORDER.RENTING_RENT ||  obj_data.booking_status == this.$constants.STATUS_ORDER.CLOSING_RENT || obj_data.booking_status == this.$constants.STATUS_ORDER.COMPLETED_RENT)">
        
        <div class="col-6" v-for="(item22, index_22) in list_term_order_renew" :key="index_22" style="margin-bottom: 16px;">
          <Panel :header="'Renewal '+(index_22+1)" >
            <div class="p-card-field">
              <div class="row">
                <div class="col-6">
                  <label class="p-col-fixed txt-right  txt_style_lable"
                  >Created date</label
                  >
                  <div class="p-col">
                    <Calendar
                        :disabled="true"
                        :showOnFocus="false"
                        dateFormat="dd/mm/yy"
                        id="end_booking_date"
                        :showIcon="true"
                        appendTo="body"
                        :showClear="true"
                        :manualInput="true"
                        v-model="item22.created_at_convert"
                        placeholder=""
                        :showTime="true"
                        :showSeconds="false"
                        @clear-click="change_rent_pick_up_date($event)"
                        @date-select="change_rent_pick_up_date($event)"
                    />
                  </div>
                </div>

                <div class="col-6">
                  <label class="p-col-fixed txt-right  txt_style_lable"
                  >Previous valid until</label
                  >
                  <div class="p-col">
                    <Calendar
                        :disabled="true"
                        :showOnFocus="false"
                        dateFormat="dd/mm/yy"
                        id="end_booking_date"
                        :showIcon="true"
                        appendTo="body"
                        :showClear="true"
                        :manualInput="true"
                        v-model="item22.previous_valid_until_convert"
                        placeholder=""
                        :showTime="true"
                        :showSeconds="false"
                    />
                  </div>
                </div>
              </div>

<!--              -->
              <div class="row">
                <div class="col-6">
                  <label class="p-col-fixed txt-right txt_style_lable"
                  >Term</label
                  >
                  <div class="p-col">
                    <InputText
                        :disabled="true"
                        type="text"
                        class=""
                        v-model="item22.name_term"
                        placeholder="Input"
                    />
                  </div>
                </div>

                <div class="col-6">
                  <label class="p-col-fixed txt-right txt_style_lable"
                  >New valid until</label
                  >
                  <div class="p-col">
                    <Calendar
                        :disabled="true"
                        :showOnFocus="false"
                        dateFormat="dd/mm/yy"
                        id="end_booking_date"
                        :showIcon="true"
                        appendTo="body"
                        :showClear="true"
                        :manualInput="true"
                        v-model="item22.valid_until_convert"
                        placeholder=""
                        :showTime="true"
                        :showSeconds="false"
                    />
                  </div>
                </div>
              </div>
<!--              -->


              <!--              -->
              <div class="row">
                <div class="col-6">
                  <label class="p-col-fixed txt-right  txt_style_lable"
                  >Price per week</label
                  >
                  <div class="p-col">
                    <div class="p-inputgroup">
                      <InputNumber
                          :disabled="true"
                          id="rent_booking_fee"
                          placeholder="Input"
                          v-model="item22.price"
                          mode="decimal"
                          :minFractionDigits="2"
                          @keyup="change_price_common"
                      />
                      <span class="p-inputgroup-addon">$</span>
                    </div>
                  </div>
                </div>

                <div class="col-6">
                  <label class="p-col-fixed txt-right  txt_style_lable"
                  >New contract ID</label
                  >
                  <div class="p-col">
                    <InputText
                        :disabled="true"
                        type="text"
                        class=""
                        v-model="item22.code"
                        placeholder="Input"
                    />
                  </div>
                </div>
              </div>
              <!--              -->

            </div>
          </Panel>
        </div>
      </div>
      <div class="col-6">
        <div class="p-card-field" style="margin-top: 8px; margin-bottom: 8px">
          <label class="p-col-fixed txt-right style_title_group txt_style_lable"
          >CONTACT INFORMATION</label
          >
          <!--          <div class="p-col">
          </div>-->
        </div>
        <div class="p-card-field">
          <label class="p-col-fixed txt-right txt-required txt_style_lable"
          >Renter</label
          >
          <div class="p-col">
            <v-select
                :disabled="core_disable('uid')"
                :clearable="true"
                class=""
                @search="SearchUser"
                placeholder="Choose"
                v-model="obj_data.uid"
                :options="listUser"
                :reduce="(item) => item.id"
                label="name"
                @input="change_list_user"
            >
              <span slot="no-options" @click="$refs.select.open = false">
                Empty data
              </span>
            </v-select>
            <input class="input_tmp_validator" id="tmp_uid"/>
          </div>
        </div>

        <div class="p-card-field">
          <label class="p-col-fixed txt-right txt-required txt_style_lable"
          >Contact name</label
          >
          <div class="p-col">
            <InputText
                :disabled="core_disable('rent_contact_name')"
                maxlength="50"
                id="rent_contact_name"
                type="text"
                class=""
                v-model="obj_data.rent_contact_name"
                placeholder="Input"
            />
          </div>
        </div>
      <!-- 1) Address -->
        <div class="p-card-field">
          <label class="p-col-fixed txt-right txt-required txt_style_lable">
            Address
          </label>

          <div class="p-col">
             <Textarea
                :disabled="core_disable('rent_contact_address')"
              maxlength="500"
              id="rent_contact_address"
              type="text"
              class=""
              v-model="obj_data.rent_contact_address"
              placeholder="Input"
            />
          </div>
        </div>
        <div class="p-card-field">
          <label class="p-col-fixed txt-right txt-required txt_style_lable"
          >Phone number</label
          >
          <div class="p-col">
            <InputText
                :disabled="core_disable('rent_contact_phone')"
                maxlength="50"
                id="rent_contact_phone"
                type="text"
                class=""
                v-model="obj_data.rent_contact_phone"
                placeholder="Input"
            />
          </div>
        </div>
        <div class="p-card-field">
          <label class="p-col-fixed txt-right txt-required txt_style_lable"
          >Email</label
          >
          <div class="p-col">
            <InputText
                :disabled="core_disable('rent_contact_email')"
                maxlength="50"
                id="rent_contact_email"
                type="text"
                class=""
                v-model="obj_data.rent_contact_email"
                placeholder="Input"
            />
          </div>
        </div>

       

        <!-- 2) License No. -->
        <div class="p-card-field">
          <label class="p-col-fixed txt-right txt-required txt_style_lable">
            License No.
          </label>

          <div class="p-col">
            <InputText
              :disabled="core_disable('rent_license_no')"
              maxlength="50"
              id="rent_license_no"
              type="text"
              class=""
              v-model="obj_data.rent_license_no"
              placeholder="Input"
            />
          </div>
        </div>

        <!-- 3) Expiry license (InputMask PrimeVue) -->
        <div class="p-card-field">
          <label class="p-col-fixed txt-right txt-required  txt_style_lable">
            Expiry license
          </label>

          <div class="p-col">
            <InputMask
              :disabled="core_disable('rent_license_expiry_date')"
              id="rent_license_expiry_date"
              v-model="obj_data.rent_license_expiry_date"
              placeholder="dd/mm/yyyy"
              mask="99/99/9999"
              slotChar="dd/mm/yyyy"
              class=""
            />
          </div>
        </div>

        <!-- 4) Linkt or E-toll account number -->
        <div class="p-card-field">
          <label class="p-col-fixed txt-right  txt_style_lable">
            Linkt / E-toll account number
          </label>

          <div class="p-col">
            <InputText
              :disabled="core_disable('rent_etoll_account_number')"
              maxlength="50"
              id="rent_etoll_account_number"
              type="text"
              class=""
              v-model="obj_data.rent_etoll_account_number"
              placeholder="Input"
            />
          </div>
        </div>

        <!-- 5) Passport -->
        <div class="p-card-field">
          <label class="p-col-fixed txt-right  txt_style_lable">
            Passport
          </label>

          <div class="p-col">
            <InputText
              :disabled="core_disable('rent_passport_no')"
              maxlength="50"
              id="rent_passport_no"
              type="text"
              class=""
              v-model="obj_data.rent_passport_no"
              placeholder="Input"
            />
          </div>
        </div>

        <div class="p-card-field">
          <label class="p-col-fixed txt-right txt-required txt_style_lable"
          >Identification information</label
          >
          <div class="p-col">
            <v-select
                :disabled="core_disable('rent_identification_information')"
                :clearable="true"
                class=""
                placeholder="Choose"
                v-model="obj_data.rent_identification_information"
                :options="list_identification_type"
                :reduce="(item) => item.id"
                label="name"
            >
              <span slot="no-options" @click="$refs.select.open = false">
                Empty data
              </span>
            </v-select>
            <input
                class="input_tmp_validator"
                id="tmp_rent_identification_information"
            />
          </div>
        </div>
        <div class="p-card-field">
          <label class="p-col-fixed txt-right txt-required txt_style_lable"
          >Number ID</label
          >
          <div class="p-col">
            <InputText
                :disabled="core_disable('rent_number_id')"
                maxlength="50"
                id="rent_number_id"
                type="text"
                class=""
                v-model="obj_data.rent_number_id"
                placeholder="Input"
            />
          </div>
        </div>

        <div class="p-card-field">
          <label class="p-col-fixed txt-right txt_style_lable">Before</label>
          <div class="p-col">
            <!-- <div class="cus-text">Recommend: 500x500px  Maximum:10 MB</div> -->
            <div class="cus-text">Accepted file:JPG, JPEG, PNG, GIF.</div>
            <input
                :disabled="core_disable('before_img')"
                class="p-inputtext p-component"
                accept="image/*"
                name="images[]"
                id="images_service"
                type="file"
                @change="onFileSelectFile"
            /><!--@change="onFileSelectLogo"-->
            <input class="input_tmp_validator" id="list_file"/>
            <div class="cus-text style_list_image">
              <div
                  class="box-image"
                  v-for="(item, index) in list_file"
                  :key="index"
              >
                <img class="style_img" :src="item.objectURL"/>
                <div class="button-clear" @click="onFileClear(item, index)" v-if="mode !='view'">
                  <img src="/assets/images/icon/cancel_black_24dp.png"/>
                </div>
              </div>
              <!--              <span :key="comFilename">{{ obj_data.filename }}</span>-->
            </div>

            <!--            <div class="select-button" style="background-color: rgb(227, 237, 252);height: max-content;text-align: justify;justify-items: center;display: flex;padding: 0.55rem;margin: -0.429rem;">
              <span style="margin: auto;">Tải lên</span>
            </div>-->
          </div>
        </div>
        <div class="p-card-field">
          <label class="p-col-fixed txt-right txt_style_lable">After</label>
          <div class="p-col">
            <!-- <div class="cus-text">Recommend: 500x500px  Maximum:10 MB</div> -->
            <div class="cus-text">Accepted file:JPG, JPEG, PNG, GIF.</div>
            <input
                :disabled="core_disable('after_img')"
                class="p-inputtext p-component"
                accept="image/*"
                name="images[]"
                id="images_service"
                type="file"
                @change="onFileSelectFileAfter"
            /><!--@change="onFileSelectLogo"-->
            <input class="input_tmp_validator" id="list_file"/>
            <div class="cus-text style_list_image">
              <div
                  class="box-image"
                  v-for="(item, index) in list_file_after"
                  :key="index"
              >
                <img class="style_img" :src="item.objectURL"/>
                <div
                    class="button-clear"
                    @click="onFileClearAfter(item, index)"
                    v-if="mode !='view'"

                >
                  <img src="/assets/images/icon/cancel_black_24dp.png"/>
                </div>
              </div>
              <!--              <span :key="comFilename">{{ obj_data.filename }}</span>-->
            </div>

            <!--            <div class="select-button" style="background-color: rgb(227, 237, 252);height: max-content;text-align: justify;justify-items: center;display: flex;padding: 0.55rem;margin: -0.429rem;">
              <span style="margin: auto;">Tải lên</span>
            </div>-->
          </div>
        </div>
        <div class="p-card-field" style="margin-top: 8px; margin-bottom: 8px">
          <label class="p-col-fixed txt-right style_title_group txt_style_lable"
          >PAYMENT INFORMATION</label
          >
          <!--          <div class="p-col">
          </div>-->
        </div>
        <!-- Price per week type number decimal 2 -->
        <div class="p-card-field">
          <label class="p-col-fixed txt-right txt-required txt_style_lable"
          >Price per week</label
          >
          <div class="p-col">
            <div class="p-inputgroup">
              <InputNumber
                  :disabled="core_disable('rent_pay_price_per_week')"
                  id="rent_pay_price_per_week"
                  placeholder="Input"
                  v-model="obj_data.rent_pay_price_per_week"
                  mode="decimal"
                  :minFractionDigits="2"
                  @keyup="change_price_common"
              />
              <span class="p-inputgroup-addon">$</span>
            </div>
          </div>
        </div>
        <!-- Bond fee -->
        <div class="p-card-field">
          <label class="p-col-fixed txt-right txt-required txt_style_lable"
          >Bond fee</label
          >
          <div class="p-col">
            <div class="p-inputgroup">
              <InputNumber
                  :disabled="core_disable('rent_pay_bond_fee')"
                  id="rent_pay_bond_fee"
                  placeholder="Input"
                  v-model="obj_data.rent_pay_bond_fee"
                  mode="decimal"
                  :minFractionDigits="2"
                  @keyup="change_price_common"
              />
              <span class="p-inputgroup-addon">$</span>
            </div>
          </div>
        </div>
        <!-- Late fee threshold    -->
        <div
            class="p-card-field"
            v-if="core_display_view('rent_late_fee_threshold_add')"
        >
          <label class="p-col-fixed txt-right txt-required txt_style_lable"
          >Late fee threshold</label
          >
          <div class="p-col">
            <!-- mode="decimal" :minFractionDigits="0" -->
            <div class="p-inputgroup">
              <InputNumber

                  id="rent_late_fee_threshold"
                  placeholder="Input"
                  v-model="obj_data.rent_late_fee_threshold"
                  @keyup="change_price_common"
              />
              <span class="p-inputgroup-addon">day</span>
            </div>
            <p>
              The weekly invoice is issued on Monday, and the late fee threshold
              is
              <b>{{
                  !$commonFuction.isEmpty(obj_data.rent_late_fee_threshold)
                      ? obj_data.rent_late_fee_threshold
                      : "x"
                }}</b>
              days. This means renters will incur a late fee if their payment is
              received after Wednesday.
            </p>
          </div>
        </div>

        <!-- Late fee per day -->
        <div
            class="p-card-field"
            v-if="core_display_view('rent_late_fee_per_day_add')"
        >
          <label class="p-col-fixed txt-right txt-required txt_style_lable"
          >Late fee per day</label
          >
          <div class="p-col">
            <div class="p-inputgroup">
              <InputNumber
                  id="rent_late_fee_per_day"
                  placeholder="Input"
                  v-model="obj_data.rent_late_fee_per_day"
                  mode="decimal"
                  :minFractionDigits="2"
                  @keyup="change_price_common"
              />
              <span class="p-inputgroup-addon">$</span>
            </div>
          </div>
        </div>
        <!-- Booking fee -->
        <div class="p-card-field">
          <label class="p-col-fixed txt-right txt-required txt_style_lable"
          >Booking fee</label
          >
          <div class="p-col">
            <div class="p-inputgroup">
              <InputNumber
                  :disabled="core_disable('rent_booking_fee')"
                  id="rent_booking_fee"
                  placeholder="Input"
                  v-model="obj_data.rent_booking_fee"
                  mode="decimal"
                  :minFractionDigits="2"
                  @keyup="change_price_common"
              />
              <span class="p-inputgroup-addon">$</span>
            </div>
          </div>
        </div>
        <!-- Late fee threshold    -->
        <div
            class="p-card-field"
            v-if="core_display_view('rent_late_fee_threshold_edit')"
        >
          <label class="p-col-fixed txt-right txt-required txt_style_lable"
          >Late fee threshold</label
          >
          <div class="p-col">
            <!-- mode="decimal" :minFractionDigits="0" -->
            <div class="p-inputgroup">
              <InputNumber
                  id="rent_late_fee_threshold"
                  placeholder="Input"
                  v-model="obj_data.rent_late_fee_threshold"
                  @keyup="change_price_common"
              />
              <span class="p-inputgroup-addon">day</span>
            </div>
            <p>
              The weekly invoice is issued on Monday, and the late fee threshold
              is
              <b>{{
                  !$commonFuction.isEmpty(obj_data.rent_late_fee_threshold)
                      ? obj_data.rent_late_fee_threshold
                      : "x"
                }}</b>
              days. This means renters will incur a late fee if their payment is
              received after Wednesday.
            </p>
          </div>
        </div>

        <!-- Late fee per day -->
        <div
            class="p-card-field"
            v-if="core_display_view('rent_late_fee_per_day_edit')"
        >
          <label class="p-col-fixed txt-right txt-required txt_style_lable"
          >Late fee per day</label
          >
          <div class="p-col">
            <div class="p-inputgroup">
              <InputNumber
                  id="rent_late_fee_per_day"
                  placeholder="Input"
                  v-model="obj_data.rent_late_fee_per_day"
                  mode="decimal"
                  :minFractionDigits="2"
                  @keyup="change_price_common"
              />
              <span class="p-inputgroup-addon">$</span>
            </div>
          </div>
        </div>
        <!-- select voucher rent_voucher_id -->
        <div
            class="p-card-field"
            :class="
            !$commonFuction.isEmpty(obj_data.rent_voucher_id)
              ? 'clear_icon_select'
              : ''
          "
            v-if="core_display_view('rent_voucher_id')"
        >
          <label class="p-col-fixed txt-right txt_style_lable">Voucher</label>
          <div class="p-col">
            <!-- @search="SearchVoucher"  @input="change_list_voucher"  -->
            <v-select
                :key="key_voucher"
                :clearable="false"
                class=""
                placeholder="Choose"
                v-model="obj_data.rent_voucher_id"
                :options="list_voucher"
                :reduce="(item) => item.id"
                label="code"
                @input="change_list_voucher"
            >
              <span slot="no-options" @click="$refs.select.open = false">
                Empty data
              </span>
            </v-select>
            <input class="input_tmp_validator" id="tmp_rent_voucher_id"/>
          </div>
        </div>

        <div
            class="p-card-field div_check"
            v-if="core_display_view('is_pay_booking_fee')"
        >
          <div class="p-col checkbox">
            <Checkbox v-model="obj_data.is_pay_booking_fee" :binary="true"/>
            <label class="p-col-fixed txt-right text">Booking fee paid</label>
          </div>
        </div>

        <div
          class="p-card-field div_check"
         
      >
        <div class="p-col checkbox">
          <Checkbox
            v-model="obj_data.is_block_auto_renew_contract_mail_push"
            :binary="true"
          />
          <label class="p-col-fixed txt-right text">
            Block auto renew contract mail / push
          </label>
        </div>
      </div>


        <div class="p-card-field" style="margin-top: 8px; margin-bottom: 8px" v-if="mode =='view'">
          <label class="p-col-fixed txt-right style_title_group txt_style_lable"
          >PAYMENT INFORMATION</label
          >
          <!--          <div class="p-col">
          </div>-->
        </div>

        <div class="p-card-field style-box-payment" style="" v-if="mode =='view'">
          <div class="box-payment">
            <div class="payment-item">
              <span class="title">Price per week</span>
              <span class="price">${{ obj_data.rent_pay_price_per_week_root }}</span>
            </div>
            <div class="payment-item" v-for="(item11, index_te) in list_term_order" :key="index_te">
              <span class="title">{{ item11.text_data }}</span>
              <span class="price">${{ $commonFuction.numberFormat(item11.price, 2, '.', ',') }}</span>
            </div>
            <div class="payment-item">
              <span class="title">Bond fee</span>
              <span class="price">${{ obj_data.rent_pay_bond_fee_root }}</span>
            </div>
            <div class="line_horizontal"></div>
            <div class="payment-item">
              <span class="title">Late fee threshold</span>
              <span class="price">{{ obj_data.rent_late_fee_threshold_root }} days</span>
            </div>
            <div class="payment-item">
              <span class="title">Late fee per day</span>
              <span class="price">${{ obj_data.rent_late_fee_per_day_root }}</span>
            </div>

          </div>


        </div>


      </div>

      <div class="col-12" v-if="mode =='view'">
        <div class="p-card-field" style="margin-top: 8px; margin-bottom: 8px">
          <label class="p-col-fixed txt-right style_title_group txt_style_lable"
          >PAYMENT TRACKING</label
          >
          <!--          <div class="p-col">
          </div>-->
        </div>
        <div class="p-card-field">
          <div class="p-col">
            <BaseDatatable
                v-if="dataModelNeedToPay"
                :key="componentKeyNeedToPay"
                :actions="getRowActionsNeedToPaid()"
                :model="dataModelNeedToPay"
                v-on:action-click="onActionClickedNeedToPaid"
            >
            </BaseDatatable>
            <!-- 
             :tableData="listDataNeedToPay" 
            :actions="getRowActionsNeedToPaid()" 
              v-on:action-click="onActionClicked"
             -->
          </div>
        </div>
      </div>

      <div class="col-6"
           v-if="mode =='view' && (obj_data.booking_status == this.$constants.STATUS_ORDER.CLOSING_RENT || obj_data.booking_status == this.$constants.STATUS_ORDER.COMPLETED_RENT)">
        <div class="p-card-field" style="margin-top: 8px; margin-bottom: 8px" v-if="mode =='view'">
          <label class="p-col-fixed txt-right style_title_group txt_style_lable">FINAL PAYMENT</label>
          <!--          <div class="p-col">
          </div>-->
        </div>

        <div class="p-card-field style-box-payment" style="" v-if="mode =='view'">
          <div class="box-payment">
            <div class="payment-item">
              <span class="title">Bond fee</span>
              <span class="price style-text-box-payment-gray">-${{ obj_data.rent_pay_bond_fee_root }}</span>
            </div>
            <div class="payment-item" v-if="obj_data.total_bill_owe && obj_data.total_bill_owe>0">
              <span class="title">Owe (*{{ obj_data.total_bill_owe }} bills)</span>
              <span class="price style-text-box-payment-gray">{{ obj_data.total_owe_filnal }}</span>
            </div>
            <div class="payment-item" v-if="obj_data.total_bill_other_cost && obj_data.total_bill_other_cost>0">
              <span class="title">Other cost ({{ obj_data.total_bill_other_cost }})</span>
              <span class="price style-text-box-payment-gray">{{ obj_data.total_other_cost_filnal }}</span>
            </div>
            <div v-if="obj_data.total_bill_other_cost && obj_data.total_bill_other_cost>0">
              <div class="payment-item style-child-other-cost"
                   v-for="(item_cost, index_cost) in obj_data.rent_list_other_cost"
                   :key="index_cost">
                <span class="title">{{ item_cost.name }}</span>
                <span class="price">
                 ${{ $commonFuction.numberFormat(item_cost.amount, 2, '.', ',') }}
                </span>
              </div>
            </div>

            <div class="line_horizontal"></div>
            <div class="payment-item">
              <span class="title">Refund bond fee (inc GST)</span>
              <span class="price"
                    style="font: normal normal bold 16px/21px Segoe UI; letter-spacing: 0px; color: #F5564E;">{{
                  obj_data.rent_late_fee_threshold_root
                }} days</span>
            </div>
            <div class="payment-item">
              <span class="title">Renter’s final payment</span>
              <span class="price"
                    style="font: normal normal bold 16px/21px Segoe UI; letter-spacing: 0px; color: #00973C;">${{
                  obj_data.rent_late_fee_per_day_root
                }}</span>
            </div>

            <div class="payment-item">
              <span class="title">{{obj_data.text_bill_owe}}</span>
            </div>
          </div>


        </div>
      </div>

      <Toolbar class="fixed-bottom-toolbar div-button">
        <template slot="right">
          <Button
              :label="$constants.TEXT_BUTTON.BACK"
              @click="backToList()"
              class="p-button-outlined"
              id="back"
          />
          <Button
              v-if="mode == 'edit'"
              :label="$constants.TEXT_BUTTON.EDIT"
              @click="saveData()"
              class="main-style-button"
          />
          <Button
              v-else-if="mode == 'add'"
              :label="$constants.TEXT_BUTTON.ADD"
              @click="saveData()"
              class="main-style-button"
          />
        </template>
      </Toolbar>
    </div>

    <Dialog
        header="Delete"
        :visible.sync="showDeleteDialog"
        :contentStyle="{ overflow: 'visible' }"
        :modal="true"
    >
      Are you want to delete this family ?
      <template #footer>
        <Button
            label="Cancel"
            @click="showDeleteDialog = false"
            icon="pi pi-times"
            class="p-button-warning"
        />
        <Button
            label="Confirm"
            @click="deleteData()"
            icon="pi pi-check"
            class="p-button-danger btn-confirm-delete-dialog style-btn-popup-confirm"
        />
      </template>
    </Dialog>

    <Dialog
        :header="`Car Picked Up?`"
        :visible.sync="showConfirmDialog"

        :contentStyle="{ overflow: 'visible',maxHeight: '80vh', overflowY: 'auto',width: '600px' }"
        :modal="true"
    >
      The user’s on the road! Now, finalize this payment: <br/><br/>
      <!-- Please note: Once confirmed, the payment details will become uneditable <br>
          within the system. -->
      <div class="popup-row">
        <div class="popup-title">Vehicle category</div>
        <div class="popup-money">{{ obj_data.rent_vehicle_category_name_root }}</div>
      </div>
      <br/>
      <div class="popup-row">
        <div class="popup-title">Price per week</div>
        <div class="popup-money">${{ obj_data.rent_pay_price_per_week_root }}</div>
      </div>
      <div class="popup-row">
        <div class="popup-title">Bond fee</div>
        <div class="popup-money">${{ obj_data.rent_pay_bond_fee_root }}</div>
      </div>
      <div class="popup-row">
        <div class="popup-title">Booking fee</div>
        <div class="popup-money">-${{ obj_data.rent_booking_fee_root }}</div>
      </div>
      <div class="line_horizontal"></div>
      <div class="popup-row">
        <div class="popup-title">Total</div>
        <div class="popup-money">${{ obj_data.total_payment_pick_up }}</div>
      </div>
      <div class="popup-row">
        <div class="checkbox">
          <Checkbox
              v-model="obj_data.rent_is_pay_pickup_pick_up"
              :binary="true"

          />
          <label class="p-col-fixed txt-right text"
          >The user has been paid <b>{{ obj_data.total_payment_pick_up }}</b></label
          >
        </div>
      </div>
      <div class="popup-row">
        <div class="form-group-popup">
          <label for="name">Contract ID</label>
          <InputText
              maxlength="50"
              id="rent_contact_name"
              type="text"
              class=""
              v-model="obj_data.contract_id_pick_up"
              placeholder="Input"
          />
        </div>
      </div>
      <div class="popup-row">
        <div class="checkbox">
          <Checkbox
              v-model="obj_data.is_allow_car_category_event"
              :binary="true"
              @change="change_allow_car_category_event"
          />
          <label class="p-col-fixed txt-right text"
          >Allow to choose a car form other category.</label
          >
        </div>
      </div>

      <div class="popup-row">
        <div class="form-group-popup">
          <label for="name" class="txt-required">License plate number</label>
          <v-select
              :key="key_car_for_rent_event"
              :clearable="false"
              class="popup_select_car_for_rent"
              @search="SearchCarForRentPick_event"
              placeholder="Choose"
              v-model="obj_data.rent_car_for_rent_id_event"
              :options="list_car_for_rent_id_event"
              :reduce="(item) => item.id"
              label="license_plate_number"
              @input="change_car_for_rent_event"
          >
                  <span slot="no-options" @click="$refs.select.open = false">
                    Empty data
                  </span>
          </v-select>
        </div>
      </div>
      <div class="popup-row car_custom_popup">
        <div class="form-group-popup">
          <label for="name">Car’s color</label>
          <InputText
              :key="key_car_for_rent_color_event"
              disabled="true"
              maxlength="50"
              type="text"
              class=""
              v-model="obj_data.color_car_forent_event"
              placeholder="Input"
          />
        </div>
      </div>


      <template #footer>

        <Button
            label="Cancel"
            @click="showConfirmDialog = false"
            icon="pi pi-times"
            class="p-button-warning"
        />
        <Button
            :disabled="!obj_data.rent_is_pay_pickup_pick_up"
            label="Confirm"
            @click="confirmDataPopup('CONFIRM_PICK_UP')"
            icon="pi pi-check"
            class="p-button-danger btn-confirm-delete-dialog style-btn-popup-confirm"
        />
      </template>
    </Dialog>

    <!-- showCancelDialog -->
    <Dialog
        header="Cancellation Confirmed"
        :visible.sync="showCancelDialog"
        :contentStyle="{ overflow: 'visible' }"
        :modal="true"
    >
      Are you sure you want to cancel this booking? Refund will be processed outside this system.
      <template #footer>
        <Button
            label="Cancel"
            @click="showCancelDialog = false"
            icon="pi pi-times"
            class="p-button-warning"
        />
        <Button
            label="Confirm"
            @click="confirmDataPopup('CANCEL_RENT')"
            icon="pi pi-check"
            class="p-button-danger btn-confirm-delete-dialog style-btn-popup-confirm"
        />
      </template>
    </Dialog>

    <Dialog
        :header="`Change the car`"
        :visible.sync="showChangeCarDialog"

        :contentStyle="{ overflow: 'visible',maxHeight: '80vh', overflowY: 'auto',width: '600px' }"
        :modal="true"
    >
      <!-- Please note: Once confirmed, the payment details will become uneditable <br>
          within the system. -->
      <div class="popup-row">
        <div class="form-group-popup">
          <label for="name">Vehicle category</label>
          <InputText
              disabled="true"

              type="text"
              class=""
              v-model="obj_data.rent_vehicle_category_name_root"
              placeholder="Input"
          />
        </div>
      </div>
      <div class="popup-row">
        <div class="checkbox">
          <Checkbox
              v-model="obj_data.is_allow_car_category_event"
              :binary="true"
              @change="change_allow_car_category_event"
          />
          <label class="p-col-fixed txt-right text"
          >Allow to choose a car form other category.</label
          >
        </div>
      </div>

      <div class="popup-row">
        <div class="form-group-popup">
          <label for="name">License plate number</label>
          <v-select
              :key="key_car_for_rent_event"
              :clearable="false"
              class="popup_select_car_for_rent"
              @search="SearchCarForRentPick_event"
              placeholder="Choose"
              v-model="obj_data.rent_car_for_rent_id_event"
              :options="list_car_for_rent_id_event"
              :reduce="(item) => item.id"
              label="license_plate_number"
              @input="change_car_for_rent_event"
          >
                  <span slot="no-options" @click="$refs.select.open = false">
                    Empty data
                  </span>
          </v-select>
        </div>
      </div>
      <div class="popup-row car_custom_popup">
        <div class="form-group-popup">
          <label for="name">Car’s color</label>
          <InputText
              disabled="true"
              :key="key_car_for_rent_color_event"
              maxlength="50"
              type="text"
              class=""
              v-model="obj_data.color_car_forent_event"
              placeholder="Input"
          />
        </div>
      </div>


      <template #footer>

        <Button
            label="Cancel"
            @click="showChangeCarDialog = false"
            icon="pi pi-times"
            class="p-button-warning"
        />
        <Button
            label="Confirm"
            @click="confirmDataPopup('CHANGE_CAR')"
            icon="pi pi-check"
            class="p-button-danger btn-confirm-delete-dialog style-btn-popup-confirm"
        />
      </template>
    </Dialog>


    <Dialog
        :header="`Reset late fee`"
        :visible.sync="showResetLateFeeDialog"

        :contentStyle="{ overflow: 'visible',maxHeight: '80vh', overflowY: 'auto',width: '600px' }"
        :modal="true"
    >
      <p>Are you sure you want to reset all late fees for this booking? This will recalculate all weekly bills,
        including the current one, to reflect this change.</p>
      <div class="popup-row">
        <div class="form-group-popup">
          <label for="name" class="txt-required ">Late fee threshold</label>
          <div class="p-inputgroup">
            <InputNumber
                id="rent_late_fee_threshold_root"
                placeholder="Input"
                v-model="obj_data.rent_late_fee_threshold_root"
                @keyup="change_price_common"
            />
            <span class="p-inputgroup-addon">day</span>
          </div>
        </div>
      </div>
      <p>The weekly invoice is issued on Monday, and the late fee threshold is 3 days. This means renters will incur a
        late fee if their payment is received after Wednesday.</p>
      <div class="popup-row">
        <div class="form-group-popup">
          <label for="name" class="txt-required ">Late fee per day</label>
          <div class="p-inputgroup">
            <InputNumber
                id="rent_late_fee_per_day_root"
                placeholder="Input"
                v-model="obj_data.rent_late_fee_per_day_root"
                mode="decimal"
                :minFractionDigits="2"
                @keyup="change_price_common"
            />
            <span class="p-inputgroup-addon">$</span>
          </div>
        </div>
      </div>
      
      <template #footer>

        <Button
            label="Cancel"
            @click="showResetLateFeeDialog = false"
            icon="pi pi-times"
            class="p-button-warning"
        />
        <Button
            label="Confirm"
            @click="confirmDataPopup('RESET_LATE_FEE')"
            icon="pi pi-check"
            class="p-button-danger btn-confirm-delete-dialog style-btn-popup-confirm"
        />
      </template>
    </Dialog>

    <Dialog
        :header="`Renew contract for this booking`"
        :visible.sync="showRenewContractDialog"

        :contentStyle="{ overflow: 'visible',maxHeight: '80vh', overflowY: 'auto',width: '600px' }"
        :modal="true"
    >
     
      <div class="popup-row">
        <div class="col-6 box-left">
          <div class="form-group-popup">
            <label for="name">Contract ID</label>
            <InputText
                :disabled="true"
                maxlength="50"
                id="rent_contact_name"
                type="text"
                class=""
                v-model="obj_data.code_contract"
                placeholder="Input"
            />
          </div>
        </div>
        <div class="col-6 box-right">
          <div class="form-group-popup">
            <label for="name">Valid until</label>
            <Calendar
                :showOnFocus="true"
                dateFormat="dd/mm/yy"
                id="renew_valid_until"
                :showIcon="true"
                :showOtherMonths="true"
                :selectOtherMonths="true"
                appendTo="body"
                :showClear="true"
                :manualInput="true"
                :readonlyInput="false"
                v-model="obj_data.return_date_convert"
                @date-select="onRenewValidUntilChanged"
                @input="onRenewValidUntilChanged"
                @blur="normalizeRenewValidUntilInput"
                placeholder="Choose"
                :showTime="true"
                :showSeconds="false"
            />
          </div>
        </div>
      </div>
      <div class="popup-row">
        <div class="form-group-popup">
          <label for="name" class="txt-required ">Term</label>
          <v-select
              :key="key_term"
              :clearable="false"
              class=""
              @search="SearchTermEvent"
              placeholder="Choose"
              v-model="obj_data.rent_term_id_root"
              :options="list_term_id_all_event"
              :reduce="(item) => item.id"
              label="name"
              @input="change_list_term"
          >
              <span slot="no-options" @click="$refs.select.open = false">
                Empty data
              </span>
          </v-select>
        </div>
      </div>
      <div class="popup-row">
        <div class="form-group-popup">
          <label for="name" class="txt-required ">Price</label>
          <div class="p-inputgroup">
            <InputNumber

                placeholder="Input"
                v-model="obj_data.rent_pay_price_per_week_new"
                mode="decimal"
                :minFractionDigits="2"
                @keyup="change_price_common"
            />
            <span class="p-inputgroup-addon">$</span>
          </div>
        </div>
      </div>
      <div class="popup-row">
        <div class="form-group-popup">
          <!--  :disabled="true" -->
          <label for="name" class="txt-required ">New valid until</label>
          <Calendar
             
              :showOnFocus="false"
              dateFormat="dd/mm/yy"
              id="renew_new_valid_until"
              :showIcon="true"
              appendTo="body"
              :showClear="true"
              :manualInput="false"
              v-model="obj_data.rent_valid_until_new"
              placeholder="Choose"
              :showTime="true"
              :showSeconds="false"
          />
        </div>
      </div>

      <div class="popup-row">
        <div class="form-group-popup">
          <label for="name" class=" ">New contract ID</label>
          <InputText
              maxlength="50"
              id="rent_contact_name"
              type="text"
              class=""
              v-model="obj_data.contract_id_new"
              placeholder="Input"
          />

        </div>
      </div>

      <template #footer>

        <Button
            label="Cancel"
            @click="showRenewContractDialog = false"
            icon="pi pi-times"
            class="p-button-warning"
        />
        <Button
            label="Confirm"
            @click="confirmDataPopup('RENEW_CONTRACT')"
            icon="pi pi-check"
            class="p-button-danger btn-confirm-delete-dialog style-btn-popup-confirm "
        />
      </template>
    </Dialog>

    <Dialog :header="`Delete payment # ${codePayment}`" :visible.sync="showDeleteDialogDeletePayment"
            :contentStyle="{ overflow: 'visible' }" :modal="true">
      <p>Are you sure you want to delete this payment? You cannot undo this action.</p>
      <div class="p-field">
        <label for="delete_reason" class="p-d-block txt-required">Why delete payment? </label><br>
        <textarea id="delete_reason" rows="3" v-model="deleteReason" :maxlength="500"
                  placeholder="Write something here (max: 500 characters)..."
                  class="p-inputtext-lg p-d-block custom-textarea"></textarea>
      </div>
      <template #footer>
        <Button label="Cancel" @click="showDeleteDialogDeletePayment = false" icon="pi pi-times"
                class="p-button-secondary"/>
        <Button label="Confirm" @click="deleteDataPayment()" icon="pi pi-check"
                class="p-button-danger  btn-confirm-delete-dialog"/>
      </template>

    </Dialog>
    <Dialog :header="`Confirm this payment #${codePayment}`" :visible.sync="showConfirmDialogConfirmPayment"
            :contentStyle="{ overflow: 'visible' }" :modal="true">
      By confirming this payment, you acknowledge that it is now fully paid. <br><br>
      Please note: Once confirmed, the payment details will become uneditable <br>
      within the system.
      <template #footer>

        <Button label="Cancel" @click="showConfirmDialogConfirmPayment = false" icon="pi pi-times"
                class="p-button-warning"/>
        <Button label="Confirm" @click="confirmDataPayment()" icon="pi pi-check"
                class="p-button-danger  btn-confirm-delete-dialog"/>
      </template>
    </Dialog>
<Dialog
      :header="`Complete this booking`"
      :visible.sync="showConfirmDialogComplete"
      
       :contentStyle="{ overflow: 'visible',maxHeight: '80vh', overflowY: 'auto',width: '600px' }"
      :modal="true"
    >
      Are you sure you want to complete this booking? <br /><br />
      <!-- Please note: Once confirmed, the payment details will become uneditable <br>
          within the system. -->
      <div class="popup-row">
        <div class="popup-title">Refund bond fee</div>
        <div style="color: #F5564E;font: normal normal bold 16px/19px Segoe UI;" class="popup-money" v-if="!$commonFuction.isEmpty(obj_data.refund_bond_fee)">{{obj_data.refund_bond_fee}}</div>
      </div>
      <div class="popup-row">
        <div class="popup-title">Renter’s final payment </div>
        <div style="color: #00973C;font: normal normal bold 16px/19px Segoe UI;" class="popup-money" v-if="!$commonFuction.isEmpty(obj_data.renter_final_payment)">{{obj_data.renter_final_payment}}</div>
      </div>
      <template #footer>
        
        <Button
          label="Cancel"
          @click="showConfirmDialogComplete = false"
          icon="pi pi-times"
          class="p-button-warning"
        />
        <Button
         
          label="Confirm"
         @click="confirmDataPopup('COMPLETE')"
          icon="pi pi-check"
          class="p-button-danger btn-confirm-delete-dialog style-btn-popup-confirm"
        />
          <!-- @click="confirmDataPopup('CONFIRM_PICK_UP')" -->
      </template>
    </Dialog>
  </form>
</template>
<script>
import moment from "moment-timezone";
import DataServices from "@/core/DataServices";
//import Common from "../../../core/Common";
import ApiRepository from "@/core/ApiRepository";
import BaseDatatable from './list_need_to_pay';

export default {
  components: {
    BaseDatatable
  },
  props: {
    mode: String,
    model: Object,
    users: Array,
  },
  data() {
    return {

      dataConfirmNeddToPay: null,

      showConfirmDialogComplete:false,
      
      codePayment: '',
      showDeleteDialogDeletePayment: false,
      showConfirmDialogConfirmPayment: false,
      deleteReason: "",
      Deselect: {
        render: (createElement) => createElement("span", "❌"),
      },

      listStatus: [
        {id: "TEMP_RENT", name: "Draft orders", style: "color:  #000000;"},
        {id: "BOOKED_RENT", name: "Booked", style: "color:  #000000;"},
        {id: "RENTING_RENT", name: "Renting", style: "color:  #000000;"},
        {id: "COMPLETED_RENT", name: "Completed", style: "color:  #000000;"},
        {id: "CANCEL_RENT", name: "Cancelled", style: "color:  #000000;"},
        {id: "CLOSING_RENT", name: "Closing", style: "color:  #000000;"},
      ],

      listUser: [],
      listUserAll: [],

      key_state: 0,
      key_vehicle_category: 0,
      key_term: 0,
      key_voucher: 0,
      key_rent_pick_up_date: 0,
      key_car_for_rent: 0,
      key_car_for_rent_event: 0,
      key_car_for_rent_color_event: 0,

      listCountry: [],
      listCountryAll: [],
      mapCountryAll: {},

      list_available_for_rent: [],
      list_available_for_rent_all: [],
      map_available_for_rent_all: {},

      list_vehicle_category_id: [],
      list_vehicle_category_id_all: [],
      map_vehicle_category_id_all: {},

      list_term_id: [],
      list_term_id_all: [],
      map_term_id_all: {},

      list_term_order: [],
      list_term_order_renew: [],

      list_term_id_event: [],
      list_term_id_all_event: [],
      map_term_id_all_event: {},

      list_showroom_id: [],
      list_showroom_id_all: [],
      map_showroom_id_all: {},
      //rent_car_for_rent_id
      list_car_for_rent_id: [],
      list_car_for_rent_id_all: [],
      map_car_for_rent_id_all: {},

      list_car_for_rent_id_event: [],
      list_car_for_rent_id_all_event: [],
      map_car_for_rent_id_all_event: {},

      // dataModelType: null,
      // componentKeyType: 1,
      // listDataType: [],

      dataModelNeedToPay: null,
      componentKeyNeedToPay: 1,
      listDataNeedToPay: [],


      listState: [],
      listStateAll: [],

      list_voucher: [],
      list_voucher_all: [],
      map_voucher_all: {},

      showDeleteDialog: false,
      showConfirmDialog: false,
      showCancelDialog: false,
      showChangeCarDialog: false,
      //Reset late fee
      showResetLateFeeDialog: false,
      //Renew contract for this booking
      showRenewContractDialog: false,

      list_id_file_delete: [],

      passwordType: "password",
      passwordReType: "password",

      file_product: null,
      list_file_product: [],
      list_id_file_delete_product: [],
      dataFamilyDisplay: false,
      componentDataFamily: 1,
      dataFamily: {},
      dataModelUserFamily: null,
      componentKeyUserFamily: 1,
      listDataUserFamily: [],

      dataModelProperty: null,
      componentKeyProperty: 1,
      listDataProperty: [],

      obj_data: {
        filename: "",
        filename_after: "",
        prefix_phone: "",

        // Notification settings (renew contract)
        // NOTE: Keep keys as backend expects. Do NOT remove existing notes.
        is_block_auto_renew_contract_mail_push: false,
      },
      comFilename: 1,
      comFilenameAfter: 1,
      list_phone_code: [
        {
          prefix_phone: "+84",
        },
        {
          prefix_phone: "+45",
        },
      ],
      dataBookingRound: [],
      selProperty: null,
      listProperty: [],
      listPropertyAll: [],
      listDocsCate: [],
      listDocsCateAll: [],
      list_action_detail: [
        // { code_change: "CANCEL_RENT", action: "Cancel" },
        // { code_change: "RENTING_RENT", action: "Confirm pick-up" },
        // { code_change: "CHANGE_CAR", action: "Change the car" },
        // { code_change: "RESET_LATE_FEE", action: "Reset late fee" },
        // { code_change: "RENEW_CONTRACT", action: "Renew" },

        // { code_change: "delete", action: "Delete" },
      ],
      from_to: null,
      address: null,
      start_booking_date: null,
      end_booking_date: null,
      partArr: [],
      time_zone_local: moment.tz.guess(true),
      componentKey: 0,
      list_file: [],
      list_file_after: [],
      list_id_file_delete_after: [],

      is_change_price: false,

      list_identification_type: [
        {
          id: 1,
          name: "Driver's license",
        },
        {
          id: 2,
          name: "Internation license",
        },
        {
          id: 3,
          name: "Passport",
        },
        {
          id: 4,
          name: "I will provide it upon pickup",
        },
      ],
      today: new Date(),
      maxFileSize: 2097152 * 50, //100MB  2MB   /*104857600, // 100MB*/
    };
  },
  watch: {
    "obj_data.is_allow_car_category_event": function () {
      //newVal, oldVal
      console.log(
          "this.obj_data.is_allow_car_category_event:",
          this.obj_data.is_allow_car_category_event
      );
      this.getListCarForRentEvent();
    },
    "obj_data.is_allow_car_category": function () {
      //newVal, oldVal

      this.getListCarForRent();
    },
    "obj_data.rent_available_id": function () {
      //newVal, oldVal
      this.generate_data();
    },
    "obj_data.rent_car_for_rent_id": function () {
      //newVal, oldVal
      console.log(
          "this.obj_data.rent_car2322_for_rent_id:",
          this.obj_data.rent_car_for_rent_id
      );
      this.generate_data();
    },
    "obj_data.rent_term_id_root": function () {
      //newVal, oldVal
      console.log(
          "this.obj_data.rent_term_id_root:",
          this.obj_data.rent_term_id_root
      );
      console.log(
          "this.list_term_id_all_event:",
          this.map_term_id_all_event[this.obj_data.rent_term_id_root]
      );
      if (!this.$commonFuction.isEmpty(this.map_term_id_all_event[this.obj_data.rent_term_id_root])) {
        var item_term = this.map_term_id_all_event[this.obj_data.rent_term_id_root];
        this.$set(this.obj_data, 'rent_pay_price_per_week_new', this.map_term_id_all_event[this.obj_data.rent_term_id_root].price_per_unit);
        //this.$set(this.obj_data.rent_pay_price_per_week_new) =  this.map_term_id_all_event[this.obj_data.rent_term_id_root].price_per_unit;
        var day_term = this.$CoreService.getDurationInDays(item_term.unit_duration, item_term.duration);
        console.log("day_term:", day_term);
        console.log("this.obj_data.timezone:", this.obj_data.timezone);
        var return_date_convert = moment(this.obj_data.return_date_convert);
        var date_end_term = return_date_convert.add(day_term, 'days').format('YYYY-MM-DD HH:mm');
        console.log("date_end_term:", date_end_term);
        this.$set(this.obj_data, 'rent_valid_until_new', new Date(date_end_term));
        // this.obj_data.rent_valid_until_new = new Date(
        //     date_end_term
        // );
        console.log(" this.obj_data.rent_valid_until_new", this.obj_data.rent_valid_until_new);
      }
    },
    "obj_data.return_date_convert": function () {
      this.recalculateRenewValidUntilNew();
    },
    "obj_data.rent_car_for_rent_id_event": function () {
      //newVal, oldVal
      console.log(
          "chyang test"
      );
      if (!this.$commonFuction.isEmpty(this.obj_data.rent_car_for_rent_id_event)) {
        console.log(
            "this.obj_data.object:",
            this.map_car_for_rent_id_all_event[this.obj_data.rent_car_for_rent_id_event]
        );
        // this.obj_data.color_car_forent_event =
        //     this.map_car_for_rent_id_all_event[
        //         this.obj_data.rent_car_for_rent_id_event
        //         ]?.color;
        this.$set(this.obj_data, 'color_car_forent_event', this.map_car_for_rent_id_all_event[this.obj_data.rent_car_for_rent_id_event]?.color);
      } else {
        //this.obj_data.color_car_forent_event = null;
        this.$set(this.obj_data, 'color_car_forent_event', null);
      }
    },
  },
  async mounted() {
    /*await this.getListProperty();
    await this.getListDocsCate();*/
    console.log("this.modethis.modethis.mode:", this.mode);
    console.log("this.model:", this.model);
    await this.getList_available_for_rent(); //hàm này đồng bộ để lấy data hiển thị post_id
    this.getListVehicleCategory();
    this.getList_showroom();
    this.getListUser();
    //this.getListCountry();
    if (this.model !== undefined && Object.keys(this.model).length > 0) {
      this.obj_data = this.$commonFuction.convertJsonObject(this.model);
      //console.log("this.obj_data:", this.obj_data);
      var timezone = this.obj_data?.time_zone ?? this.$constants.AUSTRALIA_TIMEZONE;
      this.obj_data.timezone = timezone;
      this.obj_data.filename = this.model?.item_avatar?.file_name ?? "";
      if (!this.$commonFuction.isEmpty(this.model?.item_avatar)) {
        let url = this.model?.item_avatar?.url;
        let obj = {
          id: this.model?.item_avatar?.id ?? null,
          name: this.obj_data.filename,
          file: "",
          objectURL: url,
          type: "old_edit",
        }; //type:'old_edit' nếu gặp type này ko update avatar
        this.list_file.push(obj);
      }

      this.loadButtonAction()
      //
      this.obj_data.filename_after =
          this.model?.item_avatar_after?.file_name ?? "";
      if (!this.$commonFuction.isEmpty(this.model?.item_avatar_after)) {
        let url = this.model?.item_avatar_after?.url;
        let obj = {
           id: this.model?.item_avatar_after?.id ?? null,
          name: this.obj_data.filename_after,
          file: "",
          objectURL: url,
          type: "old_edit",
        }; //type:'old_edit' nếu gặp type này ko update avatar
        this.list_file_after.push(obj);
      }
      this.obj_data.rent_car_for_rent_id = this.model.rent_car_for_rent_id
          ? this.model.rent_car_for_rent_id
          : null;
      await this.getListTerm(this.obj_data.rent_vehicle_category_id);
      await this.getListCarForRent();
      this.generate_data();

      // if (!this.$commonFuction.isEmpty(this.model.country_id)){
      //   this.getListState(this.model.country_id);
      // }
      // var user_customer_care = this.model.user_customer_care
      // if (user_customer_care.length > 0){
      //   if (!this.$commonFuction.isEmpty(user_customer_care[0]["user_customer_care"])){
      //     if (!this.$commonFuction.isEmpty(user_customer_care[0]["user_customer_care"]["sale_person_id"])){
      //       this.obj_data.sale_person_id =  user_customer_care[0]["user_customer_care"]["sale_person_id"]
      //     }
      //   }
      // }
      // if (!this.$commonFuction.isEmpty(this.model.birthday)){
      //   this.obj_data.birthday =new Date(this.model.birthday);
      //   console.log("this.obj_data.birthday:",this.obj_data.birthday)
      // }
      if (!this.$commonFuction.isEmpty(this.model.rent_pick_up_date)) {
        this.obj_data.rent_pick_up_date = new Date(
            this.model.rent_pick_up_date
        );
      }
      if (!this.$commonFuction.isEmpty(this.model.rent_valid_until)) {
        this.obj_data.rent_valid_until_root = this.model.rent_valid_until;
        this.obj_data.rent_valid_until = new Date(this.model.rent_valid_until);
      }
      this.obj_data.return_date_convert = null;
      if (!this.$commonFuction.isEmpty(this.obj_data.max_date_end_term)) {
        this.obj_data.return_date_convert = new Date( moment(this.obj_data.max_date_end_term).format(this.$constants.DB_FORMAT_DATE_TIME));
      }

      //complete_date
      this.obj_data.complete_date_convert = null;
      if (!this.$commonFuction.isEmpty(this.obj_data.complete_date)) {
        this.obj_data.complete_date_convert = new Date( moment(this.obj_data.complete_date).tz(timezone).format(this.$constants.DB_FORMAT_DATE_TIME));
      }

      this.obj_data.actual_pickup_date_convert = null;
      if (!this.$commonFuction.isEmpty(this.obj_data.actual_pickup_date)) {
        console.log("this.obj_data.timezonetimezone:", timezone);
        console.log("this.obj_data.actual_pickup_date:", moment(this.obj_data.actual_pickup_date).tz(timezone).format(this.$constants.DB_FORMAT_DATE_TIME));
        this.obj_data.actual_pickup_date_convert = new Date( moment(this.obj_data.actual_pickup_date).tz(timezone).format(this.$constants.DB_FORMAT_DATE_TIME));
      }

      if (!this.$commonFuction.isEmpty(this.model.created_at)) {
        this.obj_data.created_at = new Date(this.model.created_at);
      }

      this.obj_data.rent_booking_fee = parseFloat(this.model.rent_booking_fee);
      this.obj_data.rent_pay_price_per_week = parseFloat(
          this.model.rent_pay_price_per_week
      );
      this.obj_data.rent_pay_bond_fee = parseFloat(
          this.model.rent_pay_bond_fee
      );
      //this.obj_data.rent_late_fee_threshold =(this.model.rent_late_fee_threshold) ? parseFloat(this.model.rent_late_fee_threshold):0;
      this.$set(this.obj_data, 'rent_late_fee_threshold', (this.model.rent_late_fee_threshold) ? parseFloat(this.model.rent_late_fee_threshold):0);
      //this.obj_data.rent_late_fee_per_day = (this.model.rent_late_fee_per_day) ? parseFloat(this.model.rent_late_fee_per_day):0;
      this.$set(this.obj_data, 'rent_late_fee_per_day', (this.model.rent_late_fee_per_day) ? parseFloat(this.model.rent_late_fee_per_day):0);

      var total_payment_pick_up = this.obj_data.rent_pay_price_per_week + this.obj_data.rent_pay_bond_fee - this.obj_data.rent_booking_fee;


      this.obj_data.total_payment_pick_up = this.$commonFuction.numberFormat(total_payment_pick_up, 2, '.', ',');
      this.obj_data.rent_pay_price_per_week_root = this.$commonFuction.numberFormat(this.obj_data.rent_pay_price_per_week, 2, '.', ',');
      this.obj_data.rent_pay_bond_fee_root = this.$commonFuction.numberFormat(this.obj_data.rent_pay_bond_fee, 2, '.', ',');
      this.obj_data.rent_booking_fee_root = this.$commonFuction.numberFormat(this.obj_data.rent_booking_fee, 2, '.', ',');

      //this.obj_data.rent_late_fee_threshold_root = this.obj_data.rent_late_fee_threshold;
      this.$set(this.obj_data, 'rent_late_fee_threshold_root', this.obj_data.rent_late_fee_threshold);
      //this.obj_data.rent_late_fee_per_day_root = this.obj_data.rent_late_fee_per_day;
      this.$set(this.obj_data, 'rent_late_fee_per_day_root', this.obj_data.rent_late_fee_per_day);


      this.obj_data.rent_vehicle_category_name_root = this.obj_data.rent_vehicle_category_name;
      this.obj_data.rent_vehicle_category_id_root = this.obj_data.rent_vehicle_category_id;

      this.obj_data.contract_id_pick_up = this.obj_data.contract_id;
      this.componentKey++;

      // this.dataModelType = DataServices.getModel('role_admin_property');
      // console.log('this.dataModelType:', this.dataModelType)
      // this.componentKeyType++;

      // this.componentKey++;
      this.dataModelNeedToPay = DataServices.getModel("payment_history_order");
      console.log("this.dataModelNeedToPay:", this.dataModelNeedToPay);
      this.getListRentalOrderTerm()
      this.loadCallFee();
      this.componentKeyNeedToPay++;
      this.setDataPopup()

    } else {
      //thêm mới
      this.obj_data = {
        /* fullname: "Tuyen",
        email: "asdasdaskdjkask@gmail.com",
        prefix_phone: "+45",
        phone: "234434535",*/
        /*
        password: "123456",
        re_password: "123456",*/

        //default data

        booking_status: "BOOKED_RENT",
        active: true,
        ordinal: 1,
      };
      this.listStatus = [
        {id: "BOOKED_RENT", name: "Booked", style: "color:  #000000;"},
      ];

      var late_fee_threshold = await this.$CoreService.getSetting(
          "LATE_FEE_THRESHOLD"
      );
      console.log("late_fee_threshold:", late_fee_threshold);
      this.obj_data.rent_late_fee_threshold = !this.$commonFuction.isEmpty(
          late_fee_threshold.value
      )
          ? parseFloat(late_fee_threshold.value)
          : 0;
      var late_fee_per_day = await this.$CoreService.getSetting(
          "LATE_FEE_PER_DAY"
      );
      console.log("late_fee_per_day:", late_fee_per_day);
      this.obj_data.rent_late_fee_per_day = !this.$commonFuction.isEmpty(
          late_fee_per_day.value
      )
          ? parseFloat(late_fee_per_day.value)
          : 0;
      // this.dataModelUserFamily = DataServices.getModel('user_family');
      // this.componentKeyUserFamily++;
      this.$set(this, 'obj_data', this.$commonFuction.convertJsonObject(this.obj_data));
      this.componentKey++;
    }
  },
  methods: {
    async loadCallFee() {
      var rent_pay_bond_fee = (this.obj_data.rent_pay_bond_fee) ? parseFloat(this.obj_data.rent_pay_bond_fee) : 0;
      var rent_list_owe = this.obj_data?.rent_list_owe ?? [];
      var rent_list_other_cost = this.obj_data?.rent_list_other_cost ?? [];
      var total_owe = 0;
      var total_other_cost = 0;
      var total_bill_owe = 0;
      var total_bill_other_cost = 0;
      var arr_text_bill_owe = [];
      for (let i = 0; i < rent_list_owe.length; i++) {
        var itemData = rent_list_owe[i];
        var amount_owe = (!this.$commonFuction.isEmpty(itemData?.amount)) ? parseFloat(itemData.amount) : 0;
        total_owe += amount_owe;
        total_bill_owe++;
         arr_text_bill_owe.push(itemData?.code);
      }
      if (arr_text_bill_owe.length > 0){
            this.obj_data.text_bill_owe = `(*) `+arr_text_bill_owe.join('; ');
        }
      for (let h = 0; h < rent_list_other_cost.length; h++) {
        var itemData1 = rent_list_other_cost[h];
        var amount_cost = (!this.$commonFuction.isEmpty(itemData1?.amount)) ? parseFloat(itemData1.amount) : 0;
        total_other_cost += amount_cost;
        total_bill_other_cost++;
      }
      //listDataOtherCost
      // for (let j = 0; j < this.listDataOtherCost.length; j++) {
      //     var itemData2 = this.listDataOtherCost[j];
      //     var amount_cost2 = (!this.$commonFuction.isEmpty(itemData2?.amount)) ? parseFloat(itemData2.amount):0;
      //     total_other_cost += amount_cost2;
      //      total_bill_other_cost++;
      // }
      this.obj_data.total_bill_owe = total_bill_owe;
      this.obj_data.total_bill_other_cost = total_bill_other_cost;
      this.obj_data.rent_pay_bond_fee_filnal = '-$' + ((rent_pay_bond_fee) ? this.$commonFuction.numberFormat(rent_pay_bond_fee, 2, '.', ',') : '0.00');
      this.obj_data.total_owe_filnal = '$' + ((total_owe) ? this.$commonFuction.numberFormat(total_owe, 2, '.', ',') : '0.00');
      this.obj_data.total_other_cost_filnal = '$' + ((total_other_cost) ? this.$commonFuction.numberFormat(total_other_cost, 2, '.', ',') : '0.00');
      //console.log("this.obj_data.total_other_cost_filnal:", this.obj_data.total_other_cost_filnal);
      var total_final_payment = -rent_pay_bond_fee + total_owe + total_other_cost;
      var renter_final_payment = 0;
      var refund_bond_fee = 0;
      if (total_final_payment > 0) {
        renter_final_payment = total_final_payment;
        this.show_request = true;
      } else {
        refund_bond_fee = total_final_payment;
        this.show_request = false;
      }
      if (this.obj_data.rent_is_request_final_payment == true) {
        this.show_request = false;
      }
      this.obj_data.renter_final_payment = '$' + ((renter_final_payment) ? this.$commonFuction.numberFormat(renter_final_payment, 2, '.', ',') : '0.00');
      this.obj_data.refund_bond_fee = '-$' + ((refund_bond_fee) ? this.$commonFuction.numberFormat(Math.abs(refund_bond_fee), 2, '.', ',') : '0.00');
    },
    //getListRentalOrderTerm
    async getListRentalOrderTerm() {
      //where rental_order_id
      var where_key = {
        rental_order_id: {_eq: this.model.id},
        status: {_eq: this.$constants.STATUS_TERM.SUCCESS}
      };
      var data_list_term_order = await this.$CoreService.getListRentalOrderTerm(where_key);
      var list_term_order = data_list_term_order.list;
      var list_convert = [];
      var list_term_order_renew = [];
      var code_old = "-";
      for (var i = 0; i < list_term_order.length; i++) {
        var item = list_term_order[i];
        console.log("item.date_start:", item.date_start);
        var startDateFormat = moment(item.date_start).format('DD/MM/YYYY');
        var text_data = `Price per week (from ${startDateFormat})`;
        var is_use_vocher = false;
        if (i == 0) {
          if (this.obj_data.booking_status == this.$constants.STATUS_ORDER.RENTING_RENT) {
            var where_key_payment_history = {
              rental_order_term_id: {_eq: item.id},
              deleted: {_eq: false},
              active: {_eq: true},
              is_fisrt_pay_week: {_eq: true},
            };
            var listOneHistory = await this.$CoreService.getItemPaymentHistory(where_key_payment_history);
            var itemHistory = listOneHistory["list"][0]
            var voucher_code = itemHistory?.voucher_code ?? null;
            if (!this.$commonFuction.isEmpty(voucher_code)) {
              text_data = `1st week voucher (${voucher_code})`;//1st week voucher (SALEOFF50)
              item.price = parseFloat(itemHistory.total_payment)
              is_use_vocher = true;
            }
          }
        }

        item.text_data = text_data;
        item.created_at_convert =(item.created_at) ?  new Date(item.created_at) :null;
        console.log("item.created_at_convert:", new Date(item.created_at));
        item.previous_valid_until_convert = (item.previous_valid_until) ? new Date(moment(item.previous_valid_until).format(this.$constants.DB_FORMAT_DATE_TIME)):null;
        item.valid_until_convert = (item.date_end) ? new Date(moment(item.date_end).format(this.$constants.DB_FORMAT_DATE_TIME)):null;
       
       //item.price_format = '$' + ((item.price) ? this.$commonFuction.numberFormat(item.price, 2, '.', ',') : '0.00');
       
       //list_term_order_renew
       if (i>0){
        list_convert.push(item);
        list_term_order_renew.push(item);
       }else{
        if(is_use_vocher == true){
          list_convert.push(item);  
       }
       }
       console.log("ddddddddddddddddddddi:"+i,item);
       if(i==(list_term_order.length-1)){
        code_old = item?.code ?? '';
       }
      }
      this.obj_data.code_contract = code_old;
      console.log("obj_data.code_contract:", this.obj_data.code_contract);
      this.list_term_order = list_convert;
      this.list_term_order_renew = list_term_order_renew;
      console.log("this.list_term_order:", this.list_term_order_renew);
    },
    async validateDataDelete() {
      this.validationErrors = {};
      const fieldsToValidate = [
        {id: "delete_reason", value: this.deleteReason},
      ];
      let isFormInvalid = false;

      for (let i = 0; i < fieldsToValidate.length; i++) {
        let field = fieldsToValidate[i];
        let inputElement = document.getElementById(field.id);
        console.log('tagNametagNametagNametagNametagName', this.deleteReason);

        if (inputElement && (inputElement.tagName === "INPUT" || inputElement.tagName === "TEXTAREA" || inputElement.tagName === "SELECT")) {
          if (this.$commonFuction.isEmptyObject(field.value)) {
            inputElement.setCustomValidity(this.$constants.MSG_TEXT.INPUT_INVALID_MSG);
            isFormInvalid = true;
          } else {
            inputElement.setCustomValidity("");
          }
        }
      }
      let inpObj = document.getElementById("delete_reason");
      if (!inpObj.checkValidity() || isFormInvalid) {
        inpObj.reportValidity();
        return true;
      }
      return false;
    },
    async deleteDataPayment() {
      await this.validateDataDelete()

      let variables = {
        'data_update': {
          status: 'Fail',
          deletion_reason: this.deleteReason,
          payment_method: '-'
        },
        'where_key': {
          'id': {'_eq': this.deleteId}
        }
      };

      await this.$apollo.mutate({
        mutation: DataServices.updateData('payment_history'),
        variables: variables
      }).then(async (res) => {
        console.log("res", res);
        this.showDeleteDialogDeletePayment = false;
        this.$toast.add({
          severity: 'success',
          summary: 'Success',
          detail: 'Delete data successfully',
          life: 3000
        });
        this.componentKeyNeedToPay++;
      }).catch((error) => {
        console.error("Error:", error);
        this.$toast.add({
          severity: 'error',
          summary: 'Error',
          detail: 'There was a problem deleting the payment. Please try again.',
          life: 3000
        });
      });
    },
    async confirmDataPayment() {
      console.log('vvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvv', this.deleteId);

      
      if (this.deleteId) {
        this.showConfirmDialogConfirmPayment = false;
        let variables = {
          'data_update': {status: 'Success', payment_method: 'Other', late_fee: 0, total_late: 0},
          'where_key': {
            'id': {'_eq': this.deleteId}
          }
        }
        await this.$apollo.mutate({
          mutation: DataServices.updateData('payment_history'),
          variables: variables
        }).then(async (res) => {
          var type =this.dataConfirmNeddToPay?.type;
          if(type ==this.$constants.TYPE_PAYMENT_HISTORY.FINAL_PAYMENT){
            //update final payment
            await this.$CoreService.updateFinalPaymentBill(this.dataConfirmNeddToPay?.obj_id)
          }
          
          console.log("res", res);
          this.$toast.add({severity: 'success', summary: 'Success', detail: 'comfirm data successfully', life: 3000})
          this.componentKeyNeedToPay++;
        });
      }

    },
    async confirmDataPopup(code) {
      // var code_order = this.obj_data.code
      // var prefix_code = code_order.substring(0, 2);
      var obj_res = {};
      var dataRequest = {};
      switch (code) {
          // case this.$constants.STATUS_ORDER.EDIT:
          //   var url_edit = `/admin/list-order/edit/${this.model.id}`
          //   if (!this.$commonFuction.isEmpty(this.$route.query)){
          //     if (!this.$commonFuction.isEmpty(this.$route.query.page_transaction)){
          //       url_edit +=`?page_transaction=${this.$route.query.page_transaction}`
          //     }
          //   }
          //   console.log("url_editurl_edit:",url_edit)
          //   window.location.href = url_edit
          //   break;
        case 'CONFIRM_PICK_UP':
          //check chọn xe License plate number
          if (this.$commonFuction.isEmpty(this.obj_data.rent_car_for_rent_id_event)) {
            alert("Please choose a car");
            return;
          }
          dataRequest = {
            obj_data: this.obj_data,
          }
          this.$commonFuction.is_loading(true);
          obj_res = await this.$CoreService.sendApi('/api_admin/order/confirm_pickup_admin', dataRequest);

          if (obj_res.is_success == true) {
            alert(this.$constants.MSG_TEXT.CONFIRMED_SUCCESSFULLY);
            this.showConfirmDialog = false;
            this.reload_page_vue()
          } else {
            this.$commonFuction.is_loading(false);
            alert(obj_res.message_text);
          }
          break;
        case 'CANCEL_RENT':
          dataRequest = {
            obj_data: this.obj_data,
          }
          this.$commonFuction.is_loading(true);
          obj_res = await this.$CoreService.sendApi('/api_admin/order/cancel_order', dataRequest);

          if (obj_res.is_success == true) {
            alert(this.$constants.MSG_TEXT.CONFIRMED_SUCCESSFULLY);
            this.showConfirmDialog = false;
            this.reload_page_vue()
          } else {
            this.$commonFuction.is_loading(false);
            alert(obj_res.message_text);
          }
          break;
        case 'EDIT':
          window.location.href = `/admin/list-rental_order/edit/${this.model.id}`
          break;


        case 'CHANGE_CAR':
          if (this.$commonFuction.isEmpty(this.obj_data.rent_car_for_rent_id_event)) {
            alert("Please choose a car");
            return;
          }
          dataRequest = {
            obj_data: this.obj_data,
          }
          this.$commonFuction.is_loading(true);
          obj_res = await this.$CoreService.sendApi('/api_admin/order/change_car', dataRequest);

          if (obj_res.is_success == true) {
            alert(this.$constants.MSG_TEXT.CONFIRMED_SUCCESSFULLY);
            this.showConfirmDialog = false;
            this.reload_page_vue()
            // window.location.reload();
          } else {
            this.$commonFuction.is_loading(false);
            alert(obj_res.message_text);
          }
          break;
        case 'RESET_LATE_FEE':
          dataRequest = {
            obj_data: this.obj_data,
          }
          this.$commonFuction.is_loading(true);
          obj_res = await this.$CoreService.sendApi('/api_admin/order/reset_late_fee', dataRequest);

          if (obj_res.is_success == true) {
            alert(this.$constants.MSG_TEXT.CONFIRMED_SUCCESSFULLY);
            this.showConfirmDialog = false;
            this.reload_page_vue()
            // window.location.reload();
          } else {
            this.$commonFuction.is_loading(false);
            alert(obj_res.message_text);
          }
          break;
        case 'RENEW_CONTRACT':
          //check empty
           if (this.$commonFuction.isEmpty(this.obj_data.rent_term_id_root)) {
              alert("Please choose a term");
              return;
           }
           //rent_pay_price_per_week_new
            if (this.$commonFuction.isEmpty(this.obj_data.rent_pay_price_per_week_new)) {
               //nhập giá
               alert("Please enter price")
                return;
            }
            
            //check price >0
            if (parseFloat(this.obj_data.rent_pay_price_per_week_new) < 0) {
                alert("Price cannot be negative")
                return;
            }
            if(this.$commonFuction.validateDecimal(this.obj_data.rent_pay_price_per_week_new) != true){
              alert("Price enter a number with 2 decimal places!")
                return;
            }
           //check empty
            if (this.$commonFuction.isEmpty(this.obj_data.rent_valid_until_new)) {
                alert("Please choose a valid until");
                return;
            }
            //check thời gian lớn hơn hiện tại
            var rent_valid_until_new = moment(this.obj_data.rent_valid_until_new).format(this.$constants.DB_FORMAT_DATE_TIME_NOT_SS);
            var rent_valid_until = moment(this.obj_data.return_date_convert).format(this.$constants.DB_FORMAT_DATE_TIME_NOT_SS);
            if (moment(rent_valid_until_new).isBefore(rent_valid_until)) {
                this.showValidationConfirm("New valid until must be greater than Valid until.");
                return;
            }
            //CHECK rent_valid_until_new SO VỚI THOI GIAN HIỆN TẠI
            var current_time_check = moment().format(this.$constants.DB_FORMAT_DATE_TIME_NOT_SS);
            if (moment(rent_valid_until_new).isBefore(current_time_check)) {
                this.showValidationConfirm("New valid until must be greater than the current time.");
                return;
            }
            
          var rent_valid_until_new_convert = moment(this.obj_data.rent_valid_until_new).format(this.$constants.DB_FORMAT_DATE_TIME_NOT_SS); 
          this.obj_data.rent_valid_until_new_convert = rent_valid_until_new_convert; 

          var rent_start_date = moment(this.obj_data.return_date_convert).format(this.$constants.DB_FORMAT_DATE_TIME_NOT_SS);
          this.obj_data.rent_start_date = rent_start_date; 
          dataRequest = {
            obj_data: this.obj_data,
          }
          this.$commonFuction.is_loading(true);
          obj_res = await this.$CoreService.sendApi('/api_admin/order/renew_contract', dataRequest);

          if (obj_res.is_success == true) {
            alert(this.$constants.MSG_TEXT.CONFIRMED_SUCCESSFULLY);
            this.showConfirmDialog = false;
            this.reload_page_vue()
            // window.location.reload();
          } else {
            this.$commonFuction.is_loading(false);
            alert(obj_res.message_text);
          }
          break;
          case 'COMPLETE':
          dataRequest = {
                        type_action:2,
                        id:this.obj_data.id
                      }
                      
                      this.$commonFuction.is_loading(true);
                      obj_res = await this.$CoreService.sendApi('/api_admin/order/complete_payment_request',dataRequest);
                      
                      if(obj_res.is_success ==true){
                        alert(this.$constants.MSG_TEXT.CONFIRMED_SUCCESSFULLY);
                        this.showConfirmDialogComplete = false;
                        window.location.reload();
                      }else{
                        this.$commonFuction.is_loading(false);
                        alert(obj_res.message_text);
                      }
          break;
        default:
          //text = "Looking forward to the Weekend";
      }
    },
    async reload_page_vue() {
      window.location.reload();

    },
    async setDataPopup() {
      this.$set(this.obj_data, 'is_allow_car_category_event', this.obj_data.is_allow_car_category);
      await this.getListCarForRentEvent();
      this.$set(this.obj_data, 'rent_car_for_rent_id_event', this.obj_data.rent_car_for_rent_id);
      await this.getListTermEvent(this.obj_data.rent_vehicle_category_id);
      this.$set(this.obj_data, 'rent_term_id_root', this.obj_data.rent_term_id);
    },
    //Trạng thái rent: BOOKED_RENT,RENTING_RENT,COMPLETED_RENT,CANCEL_RENT
    //main-style-button style_btn_grey
    loadButtonAction() {
      var map_action = {
        BOOKED_RENT: [
          {code_change: "CANCEL_RENT", action: "Cancel", class_button: 'style_btn_grey'},
          {code_change: "EDIT", action: "Edit", class_button: 'main-style-button'},
          {code_change: "CONFIRM_PICK_UP", action: "Confirm pick-up", class_button: 'main-style-button'}
        ],
        RENTING_RENT: [
          {code_change: "CHANGE_CAR", action: "Change the car", class_button: 'style_btn_grey'},
          {code_change: "RESET_LATE_FEE", action: "Reset late fee", class_button: 'style_btn_grey'},
          {code_change: "RENEW_CONTRACT", action: "Renew", class_button: 'main-style-button'},
          {code_change: "COMPLETE", action: "Complete", class_button: 'main-style-button'},
        ],
        CLOSING_RENT: [
          {code_change: "COMPLETE", action: "Complete", class_button: 'main-style-button'},
        ],
      }
      console.log('this.obj_data.booking_status:', this.obj_data.booking_status)
      console.log('this.obj_data.dddddddddddddd:', map_action[this.obj_data.booking_status])

      if (map_action[this.obj_data.booking_status]) {
        this.list_action_detail = map_action[this.obj_data.booking_status];
      }

    },
    async onActionClickedNeedToPaid(payload) {
      console.log('payloadpayloadpayloadpayloadpayloadpayloadpayload', payload);

      var action = payload.action
      var data = null
      if (payload.data) {
        data = payload.data
      }
      var pageTransaction = (new Date()).getTime();
      switch (action.name) {
        case 'view':
          this.dialogMode = action.name
          if (data.data?.status == 'ST002') {
            this.$router.push({path: `/admin/list-visit/edit/${data.data?.order?.visit?.id}`})
            return;
          }
          if (action.path !== undefined && action.path) {
            this.$router.push({path: action.path + data.data[action.key]})
          } else {
            this.editId = data.data[action.key]
            this.displayDialog = true
            this.editDialogKey++
          }
          break
        case 'edit':
          this.dialogMode = action.name
          if (action.path !== undefined && action.path) {
            console.log("payload.lazyParams:111" + pageTransaction, payload.lazyParams);
            localStorage.setItem(pageTransaction.toString(), JSON.stringify(payload.lazyParams));
            this.$router.push({
              path: `/admin/list-payment_history/edit/${data.data[action.key]}` ,
              query: {page_transaction: pageTransaction.toString(),id_order: this.$route.params.id}
            })
          } else {
            this.editId = data.data[action.key]
            this.displayDialog = true
            this.editDialogKey++
          }
          break
        case 'delete':
          console.log('aaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaa', data.data[action.key]);
          this.codePayment = data.data.code;
          localStorage.setItem(pageTransaction.toString(), JSON.stringify(payload.lazyParams));
          this.page_transaction = pageTransaction;
          console.log(data.data);
          this.deleteId = data.data[action.key]
          this.deleteName = data.data.name
          this.showDeleteDialogDeletePayment = true
          break
        case 'add':
          this.dialogMode = action.name
          if (action.path !== undefined && action.path) {
            this.$router.push({path: `/admin/list-payment_history/add?id_order=${this.$route.params.id}`})
          } else {
            this.displayDialog = true
            this.editDialogKey++
          }
          break
        case 'confirm':
          this.codePayment = data.data.code;
          localStorage.setItem(pageTransaction.toString(), JSON.stringify(payload.lazyParams));
          this.page_transaction = pageTransaction;
          console.log(data.data);
          this.dataConfirmNeddToPay = data.data;
          this.deleteId = data.data[action.key]
          this.deleteName = data.data.name
          this.showConfirmDialogConfirmPayment = true
          break
        case 'custom':
          await action.handler(data.data, this)
          this.componentKey++
          break
      }
    },
    getRowActionsNeedToPaid() {
      var actions = {}
      var that = this;
      //if (this.role.add) {
      //booking_status
      if(this.obj_data.booking_status == this.$constants.STATUS_ORDER.RENTING_RENT){
        actions.header = {name: 'add', icon: 'plus', path: `list-payment_history/add`};
      }
      //}
      // actions.header = { name: 'add', icon: 'plus'};
      actions.rows = function (rowData) {
        console.log('111111111111111111111111111111111111111', rowData.status);

        var buttons = {}
        if (rowData.status == 'Need to pay') {
          buttons.view = {name: 'confirm', icon: 'check-circle', key: 'id', path: `list-payment_history/view/`};
          //if (that.role.delete) {
          buttons.delete = {name: 'delete', icon: 'trash', key: 'id'}
          // }
        }
        if (rowData.status === 'Need to pay' && rowData.type === 3) {
          //if (that.role.edit) {
            buttons.edit = { name: 'edit', icon: 'pencil', key: 'id', path: `list-payment_history/edit/` };
          //}
        }
        //  if (rowData.status === 'Need to pay' && rowData.type === 3) {
        //   if (that.role.edit) {
        //     buttons.edit = { name: 'edit', icon: 'pencil', key: 'id', path: `list-${that.modelName}/edit/` };
        //   }
        // }
        // buttons.edit = { name: 'edit', icon: 'pencil', key: 'id', path: `${that.modelName}/edit/`}


        if (that.dataModelNeedToPay.actions) {
          var modelaction = that.dataModelNeedToPay.actions(rowData)
          Object.assign(buttons, modelaction);
        }
        return buttons
      }
      return actions
    },
    async click_change_status(code) {
      // var code_order = this.obj_data.code
      // var prefix_code = code_order.substring(0, 2);
      switch (code) {
          // case this.$constants.STATUS_ORDER.EDIT:
          //   var url_edit = `/admin/list-order/edit/${this.model.id}`
          //   if (!this.$commonFuction.isEmpty(this.$route.query)){
          //     if (!this.$commonFuction.isEmpty(this.$route.query.page_transaction)){
          //       url_edit +=`?page_transaction=${this.$route.query.page_transaction}`
          //     }
          //   }
          //   console.log("url_editurl_edit:",url_edit)
          //   window.location.href = url_edit
          //   break;
        case 'CONFIRM_PICK_UP':

          if (this.obj_data.rent_identification_information==this.$constants.IDENTIFICATION_INFORMATION.I_WILL_PROVIDE_IT_UPON_PICKUP) {
            alert("The renter's identification details have yet to be updated for this booking. Kindly ensure that this information is completed prior to confirming the vehicle pickup");
            return;
          }

          this.showConfirmDialog = true;
          // var rent_car_for_rent_id_event_tmp = this.obj_data.rent_car_for_rent_id_event;
          // this.$set(this.obj_data, 'rent_car_for_rent_id_event', null);
          // this.$set(this.obj_data, 'rent_car_for_rent_id_event', null);
          break;
        case 'CANCEL_RENT':
          this.showCancelDialog = true;
          break;
        case 'EDIT':
          window.location.href = `/admin/list-rental_order/edit/${this.model.id}`
          break;


        case 'CHANGE_CAR':
          this.getListCarForRentEvent();
          this.showChangeCarDialog = true;
          break;
        case 'RESET_LATE_FEE':
          this.showResetLateFeeDialog = true;
          break;
        case 'RENEW_CONTRACT':
          this.showRenewContractDialog = true;
          break;
        case 'COMPLETE':
          if(this.obj_data.booking_status == this.$constants.STATUS_ORDER.CLOSING_RENT){
            this.showConfirmDialogComplete = true;
          }else{
            var router_back = {path: `/admin/list-rental_order/complete/${this.model.id}`};
          this.$router.push(router_back);
          }
          break;

        default:
          //text = "Looking forward to the Weekend";
      }
    },
    change_allow_car_category() {
      this.$set(this.obj_data, 'rent_car_for_rent_id', null);
    },
    change_allow_car_category_event() {
      this.$set(this.obj_data, 'rent_car_for_rent_id_event', null);
    },
    change_car_for_rent_event() {
      this.key_car_for_rent_event++;
      this.key_car_for_rent_color_event++;
      console.log("this.obj_data.rent_car_for_rent_id_event:3333333333333");
      //this.generate_data();
    },
    change_car_for_rent() {
      this.key_car_for_rent++;
      //this.generate_data();
    },
    generate_data() {
      var post_id = "";
      console.log(
          "this.obj_data.rent_available_iddddddddddddd:",
          this.obj_data.rent_available_id
      );
      if (!this.$commonFuction.isEmpty(this.obj_data.rent_available_id)) {
        post_id =
            this.map_available_for_rent_all[this.obj_data.rent_available_id]
                ?.code;
      }
      //this.obj_data.post_id = post_id;
      this.$set(this.obj_data, "post_id", post_id);
      console.log("this.obj_data.rent_car_for_rent_id:444444444");

      if (!this.$commonFuction.isEmpty(this.obj_data.rent_car_for_rent_id)) {
        console.log(
            "this.obj_data.object:",
            this.map_car_for_rent_id_all[this.obj_data.rent_car_for_rent_id]
        );
        //this.obj_data.color_car_forent =this.map_car_for_rent_id_all[this.obj_data.rent_car_for_rent_id]?.color;
        this.$set(this.obj_data, "color_car_forent",this.map_car_for_rent_id_all[this.obj_data.rent_car_for_rent_id]?.color);
      } else {
        this.obj_data.color_car_forent = null;
      }
    },
    core_disable(input_name = "") {
      // console.log("sasasawqwqfdf")
      var is_return = false;
      //dùng switch case để xử lý các trường hợp disable
      // console.log("this.mode:", this.mode);
      if (this.mode == "view") {
        return true;
      }
      switch (input_name) {
        case "booking_status":
          if (this.mode == "edit") {
            is_return = true;
          }
          break;
        case "color_car_forent":
          is_return = true;
          break;
        case "created_at":
          is_return = true;
          break;
        case "post_id":
          is_return = true;
          break;
        case "rent_available_id":
          is_return = false;
          break;
        case "rent_vehicle_category_id":
          is_return = false;
          break;
        case "rent_term_id":
          is_return = false;
          break;
        case "rent_pick_up_date":
          is_return = false;
          break;
        case "rent_valid_until":
          is_return = false;
          break;
        case "showroom_id":
          is_return = false;
          break;
        case "contract_id":
          is_return = false;
          break;
        case "note":
          is_return = false;
          break;
        case "uid":
          is_return = false;
          break;
        case "rent_contact_name":
          is_return = false;
          break;
        case "rent_contact_phone":
          is_return = false;
          break;
        case "rent_contact_email":
          is_return = false;
          break;
        case "rent_contact_address":
          is_return = false;
          break;

        case "rent_license_no":
          is_return = false;
          break;

        case "rent_license_expiry_date":
          is_return = false;
          break;

        case "rent_etoll_account_number":
          is_return = false;
          break;

        case "rent_passport_no":
          is_return = false;
          break;


        case "rent_identification_information":
          is_return = false;
          break;
        case "rent_number_id":
          is_return = false;
          break;
        case "rent_pay_price_per_week":
          is_return = false;
          break;
        case "rent_pay_bond_fee":
          is_return = false;
          break;
        case "rent_late_fee_threshold":
          is_return = false;
          break;
        case "rent_late_fee_per_day":
          is_return = false;
          break;
        case "rent_booking_fee":
          if (this.mode == "edit") {
            is_return = true;
          }
          break;
        case "rent_voucher_id":
          is_return = false;
          break;
        case "is_pay_booking_fee":
          is_return = false;
          break;
        default:
      }
      // console.log("is_return:"+input_name,is_return)
      return is_return;
    },
    core_display_view(input_name = "") {
      //dùng switch case để xử lý các trường hợp disable
      var is_return = false;
      switch (input_name) {
        case "rent_late_fee_threshold_edit":
          if (this.mode == "edit") {
            is_return = true;
            //console.log("rent_late_fee_threshold_edit",is_return)
          }
          break;
        case "rent_late_fee_per_day_edit":
          if (this.mode == "edit") {
            is_return = true;
            // console.log("rent_late_fee_per_day_edit",is_return)
          }
          break;
        case "rent_late_fee_per_day_add":
          if (this.mode == "add") {
            is_return = true;
            //  console.log("rent_late_fee_per_day_add",is_return)
          }
          break;
        case "rent_late_fee_threshold_add":
          if (this.mode == "add") {
            is_return = true;
            //  console.log("rent_late_fee_threshold_add",is_return)
          }
          break;
        case "group_car_forrent_id":
          if (this.mode != "add") {
            is_return = true;
          }
          break;
        case "is_allow_car_category":
          if (this.mode == "edit") {
            is_return = true;
          }
          break;
        case "group_created_at_post_id":
          if (this.mode != "add") {
            is_return = true;
          }
          break;
        case "booking_status":
          if (this.mode == "edit") {
            is_return = true;
          }
          break;
        case "created_at":
          is_return = true;
          break;
        case "rent_available_id":
          if (this.mode == "add") {
            is_return = true;
          }
          break;
        case "rent_vehicle_category_id":
          is_return = false;
          break;
        case "rent_term_id":
          is_return = false;
          break;
        case "rent_pick_up_date":
          is_return = false;
          break;
        case "rent_valid_until":
          is_return = false;
          break;
        case "showroom_id":
          is_return = false;
          break;
        case "contract_id":
          is_return = false;
          break;
        case "note":
          is_return = false;
          break;
        case "uid":
          is_return = false;
          break;
        case "rent_contact_name":
          is_return = false;
          break;
        case "rent_contact_phone":
          is_return = false;
          break;
        case "rent_contact_email":
          is_return = false;
          break;
        case "rent_identification_information":
          is_return = false;
          break;
        case "rent_number_id":
          is_return = false;
          break;
        case "rent_pay_price_per_week":
          is_return = false;
          break;
        case "rent_pay_bond_fee":
          is_return = false;
          break;
        case "rent_late_fee_threshold":
          is_return = false;
          break;
        case "rent_late_fee_per_day":
          is_return = false;
          break;
        case "rent_booking_fee":
          is_return = false;
          break;
        case "rent_voucher_id":
          if (this.mode == "add") {
            is_return = true;
          }
          break;
        case "is_pay_booking_fee":
          if (this.mode == "add") {
            is_return = true;
          }
          break;
        default:
      }
      return is_return;
    },
    //is_change_price
    async change_price_common() {
      this.is_change_price = true;
    },
    // function call api api_admin/order/list_voucher get list voucher
    // call api
    async loadVoucher() {
      this.obj_data.rent_voucher_id = null;
      var user_id = this.obj_data.uid;
      var term_id = this.obj_data.rent_term_id;
      console.log("user_id:", user_id);
      console.log("term_id:", term_id);
      if (
          this.$commonFuction.isEmpty(user_id) ||
          this.$commonFuction.isEmpty(term_id)
      ) {
        this.list_voucher = [];
        return;
      }
      var dataRequest = {
        user_id: user_id,
        term_id: term_id,
        type_condition: 2,
      };
      const headers = {
        Authorization: "Bearer " + (await this.$AuthenticationApp.getToken()),
      };
      var list_action_detail = await ApiRepository.post(
          "/api_admin/order/list_voucher",
          dataRequest,
          {headers}
      );
      var listData = list_action_detail["data"]["data"];
      console.log("listData:", listData);
      this.list_voucher = listData;
    },
    async change_list_user() {
      //loa
      this.loadVoucher();
    },
    removeSpaces() {
      // Loại bỏ tất cả khoảng cách
      this.obj_data.phone = this.obj_data.phone.replace(/\s+/g, "");
    },
    async getListUser() {
      var where_key = {
        deleted: {_eq: false},
        role: {_eq: this.$constants.ROLE_ACCOUNT.USER},
        // booking: {id: {_is_null: true} },
      };
      var list = await this.$CoreService.getListUser(where_key);
      this.listUser = list.list;
      this.listUserAll = list.list;
    },
    async SearchUser(search, loading) {
      console.log(loading);
      if (search !== "" && search !== null) {
        var where_key = {
          deleted: {_eq: false},
          role: {_eq: this.$constants.ROLE_ACCOUNT.USER},
        };
        if (!this.$commonFuction.isEmpty(search)) {
          where_key.fullname = {
            _iregex: this.$commonFuction.search(search),
          };
        }
        var list = await this.$CoreService.getListUser(where_key);
        this.listUser = list.list;
        //console.log("this.listProperty:",this.listProperty)
      } else {
        // cosnole.log("dasdasd")
        this.listUser = this.listUserAll;
      }
    },
    async change_list_voucher() {
      this.key_voucher++;
    },
    async changeState() {
      this.key_state++;
    },
    async change_rent_pick_up_date() {
      this.calcValidUntil();
    },
    onRenewValidUntilChanged(value) {
      if (this.$commonFuction.isEmpty(value)) {
        return;
      }
      if (value instanceof Date && !isNaN(value.getTime())) {
        this.$set(this.obj_data, "return_date_convert", value);
        this.recalculateRenewValidUntilNew();
        return;
      }
      if (typeof value === "string") {
        const parsed = moment(value, "DD/MM/YYYY HH:mm", true);
        if (parsed.isValid()) {
          this.$set(this.obj_data, "return_date_convert", parsed.toDate());
          this.recalculateRenewValidUntilNew();
        }
      }
    },
    normalizeRenewValidUntilInput(event) {
      const rawValue = event?.target?.value ?? "";
      if (this.$commonFuction.isEmpty(rawValue)) {
        return;
      }
      const parsed = moment(rawValue, "DD/MM/YYYY HH:mm", true);
      if (parsed.isValid()) {
        this.$set(this.obj_data, "return_date_convert", parsed.toDate());
        this.recalculateRenewValidUntilNew();
      }
    },
    recalculateRenewValidUntilNew() {
      if (
          this.$commonFuction.isEmpty(this.obj_data.return_date_convert) ||
          this.$commonFuction.isEmpty(this.map_term_id_all_event[this.obj_data.rent_term_id_root])
      ) {
        return;
      }
      var item_term = this.map_term_id_all_event[this.obj_data.rent_term_id_root];
      var day_term = this.$CoreService.getDurationInDays(item_term.unit_duration, item_term.duration);
      var return_date_convert = moment(this.obj_data.return_date_convert);
      var date_end_term = return_date_convert.add(day_term, 'days').format('YYYY-MM-DD HH:mm');
      this.$set(this.obj_data, 'rent_valid_until_new', new Date(date_end_term));
    },
    showValidationConfirm(message) {
      this.$confirm.require({
        header: "Confirm",
        message: message,
        icon: "pi pi-exclamation-triangle",
        acceptLabel: "OK",
        rejectVisible: false,
        accept: () => {},
      });
    },
    async change_list_term() {
      // this.obj_data.rent_term_id =null;
      // this.getListTerm(this.obj_data.rent_vehicle_category_id);
      // this.key_term++;
      var item_term = this.map_term_id_all[this.obj_data.rent_term_id];
      if (this.is_change_price == false) {
        //this.obj_data.rent_booking_fee = item_term.booking_fee;
        //this.obj_data.rent_pay_price_per_week = item_term.price_per_unit;
        this.$set(this.obj_data, "rent_pay_price_per_week", item_term.price_per_unit);
        this.$set(this.obj_data, "rent_booking_fee", item_term.booking_fee);
      }

      this.calcValidUntil();
      this.loadVoucher();
    },
    calcValidUntil() {
      if (
          !this.$commonFuction.isEmpty(this.obj_data.rent_pick_up_date) &&
          !this.$commonFuction.isEmpty(this.obj_data.rent_term_id)
      ) {
        var item_term = this.map_term_id_all[this.obj_data.rent_term_id];
        //  var day_term = getDurationInDays(item_term.unit_duration,item_term.duration);
        var day_term = this.$CoreService.getDurationInDays(
            item_term.unit_duration,
            item_term.duration
        );
        const rent_pick_up_date = moment(this.obj_data.rent_pick_up_date);
        //const rent_pick_up_dateFormat = moment(this.obj_data.rent_pick_up_date).format(this.$constants.DB_FORMAT_DATE_TIME);
        const rent_valid_until = rent_pick_up_date
            .add(day_term, "days")
            .format(this.$constants.DB_FORMAT_DATE_TIME_NOT_SS);
       // this.obj_data.rent_valid_until = new Date(rent_valid_until);
        this.$set(this.obj_data, "rent_valid_until", new Date(rent_valid_until));

        console.log("rent_valid_until:", rent_valid_until);
        // this.key_rent_pick_up_date
      }
    },
    async getListTerm(rent_vehicle_category_id = null) {
      var where_key = {
        deleted: {_eq: false},
        // booking: {id: {_is_null: true} },
      };
      if (!this.$commonFuction.isEmpty(rent_vehicle_category_id)) {
        where_key["vehicle_category_id"] = {_eq: rent_vehicle_category_id};
      }
      var list = await this.$CoreService.getListTerm(where_key);
      this.list_term_id = list.list;
      this.list_term_id_all = list.list;
      this.map_term_id_all = list.map_list;
    },
    async SearchTerm(search, loading) {
      console.log(loading);
      if (search !== "" && search !== null) {
        var where_key = {
          deleted: {_eq: false},
        };
        if (!this.$commonFuction.isEmpty(this.model.rent_vehicle_category_id)) {
          where_key["rent_vehicle_category_id"] = {
            _eq: this.model.rent_vehicle_category_id,
          };
        }
        if (!this.$commonFuction.isEmpty(search)) {
          where_key.name = {
            _iregex: this.$commonFuction.search(search),
          };
        }
        var list = await this.$CoreService.getListTerm(where_key);
        this.list_term_id = list.list;
        //console.log("this.listProperty:",this.listProperty)
      } else {
        this.list_term_id = this.list_term_id_all;
      }
    },
    //event getListTerm
    async getListTermEvent(rent_vehicle_category_id = null) {
      var where_key = {
        deleted: {_eq: false},
        // booking: {id: {_is_null: true} },
      };
      if (!this.$commonFuction.isEmpty(rent_vehicle_category_id)) {
        where_key["vehicle_category_id"] = {_eq: rent_vehicle_category_id};
      }
      var list = await this.$CoreService.getListTerm(where_key);
      this.list_term_id_event = list.list;
      this.list_term_id_all_event = list.list;
      this.map_term_id_all_event = list.map_list;
    },
    async SearchTermEvent(search, loading) {
      console.log(loading);
      if (search !== "" && search !== null) {
        var where_key = {
          deleted: {_eq: false},
        };
        if (!this.$commonFuction.isEmpty(this.model.rent_vehicle_category_id)) {
          where_key["rent_vehicle_category_id"] = {
            _eq: this.model.rent_vehicle_category_id,
          };
        }
        if (!this.$commonFuction.isEmpty(search)) {
          where_key.name = {
            _iregex: this.$commonFuction.search(search),
          };
        }
        var list = await this.$CoreService.getListTerm(where_key);
        this.list_term_id_event = list.list;
        //console.log("this.listProperty:",this.listProperty)
      } else {
        this.list_term_id_event = this.list_term_id_all_event;
      }
    },  //event getListCarForRent
    //list_car_for_rent_id_event
    async getListCarForRentEvent() {
      var where_key = {
        deleted: {_eq: false},
        // booking: {id: {_is_null: true} },
      };
      if (this.obj_data.is_allow_car_category_event != true) {
        where_key["vehicle_category_id"] = {
          _eq: this.obj_data.rent_vehicle_category_id_root,
        };
      }
      var list = await this.$CoreService.getListCarForRent(where_key);
      this.list_car_for_rent_id_event = list.list;
      this.list_car_for_rent_id_all_event = list.list;
      this.map_car_for_rent_id_all_event = list.map_list;
    },
    async SearchCarForRentPick_event(search, loading) {
      console.log(loading);
      if (search !== "" && search !== null) {
        var where_key = {
          deleted: {_eq: false},
        };
        if (this.obj_data.is_allow_car_category_event != true) {
          where_key["vehicle_category_id"] = {
            _eq: this.obj_data.rent_vehicle_category_id_root,
          };
        }
        if (!this.$commonFuction.isEmpty(search)) {
          where_key.license_plate_number = {
            _iregex: this.$commonFuction.search(search),
          };
        }
        var list = await this.$CoreService.getListCarForRent(where_key);
        this.list_car_for_rent_id_event = list.list;
        //console.log("this.listProperty:",this.listProperty)
      } else {
        // cosnole.log("dasdasd")
        this.list_car_for_rent_id_event = this.list_car_for_rent_id_all_event;
      }
    },

    //car_for_rent_id
    async getListCarForRent() {
      var where_key = {
        deleted: {_eq: false},
        // booking: {id: {_is_null: true} },
      };
      if (this.obj_data.is_allow_car_category != true) {
        where_key["vehicle_category_id"] = {
          _eq: this.obj_data.rent_vehicle_category_id,
        };
      }
      var list = await this.$CoreService.getListCarForRent(where_key);
      this.list_car_for_rent_id = list.list;
      this.list_car_for_rent_id_all = list.list;
      this.map_car_for_rent_id_all = list.map_list;
    },
    async SearchCarForRent(search, loading) {
      console.log(loading);
      if (search !== "" && search !== null) {
        var where_key = {
          deleted: {_eq: false},
        };
        if (this.obj_data.is_allow_car_category != true) {
          where_key["vehicle_category_id"] = {
            _eq: this.obj_data.rent_vehicle_category_id,
          };
        }
        if (!this.$commonFuction.isEmpty(search)) {
          where_key.license_plate_number = {
            _iregex: this.$commonFuction.search(search),
          };
        }
        var list = await this.$CoreService.getListCarForRent(where_key);
        this.list_car_for_rent_id = list.list;
        //console.log("this.listProperty:",this.listProperty)
      } else {
        // cosnole.log("dasdasd")
        this.list_car_for_rent_id = this.list_car_for_rent_id_all;
      }
    },
    async change_list_vehicle_category() {
      var item_category =
          this.map_vehicle_category_id_all[
              this.obj_data.rent_vehicle_category_id
              ];
      if (this.is_change_price == false) {
        //this.obj_data.rent_pay_bond_fee = item_category.bond_fee;
        this.$set(this.obj_data, "rent_pay_bond_fee", item_category.bond_fee);
      }
      this.$set(this.obj_data, "rent_term_id", null);
      //this.obj_data.rent_term_id = null;
      this.getListTerm(this.obj_data.rent_vehicle_category_id);
      this.obj_data.rent_car_for_rent_id = null;
      this.getListCarForRent();
      this.key_term++;
    },
    //rent_car_for_rent_id =null
    async getListVehicleCategory() {
      var where_key = {
        deleted: {_eq: false},
        // booking: {id: {_is_null: true} },
      };
      // if (!this.$commonFuction.isEmpty(rent_car_for_rent_id)){
      //   where_key["rent_car_for_rent_id"] =  {_eq : rent_car_for_rent_id}
      // }
      var list = await this.$CoreService.getLisVehicleCategory(where_key);
      this.list_vehicle_category_id = list.list;
      this.list_vehicle_category_id_all = list.list;
      this.map_vehicle_category_id_all = list.map_list;
    },
    async SearchVehicleCategory(search, loading) {
      console.log(loading);
      if (search !== "" && search !== null) {
        var where_key = {
          deleted: {_eq: false},
        };
        // if (!this.$commonFuction.isEmpty(this.model.rent_car_for_rent_id)){
        //   where_key["rent_car_for_rent_id"] =  {_eq : this.model.rent_car_for_rent_id}
        // }
        if (!this.$commonFuction.isEmpty(search)) {
          where_key.name = {
            _iregex: this.$commonFuction.search(search),
          };
        }
        var list = await this.$CoreService.getLisVehicleCategory(where_key);
        this.list_vehicle_category_id = list.list;
        //console.log("this.listProperty:",this.listProperty)
      } else {
        // cosnole.log("dasdasd")
        this.list_vehicle_category_id = this.list_vehicle_category_id_all;
      }
    },
    async getList_showroom() {
      var where_key = {
        deleted: {_eq: false},
        // booking: {id: {_is_null: true} },
      };
      var list = await this.$CoreService.getLisShowroom(where_key);
      this.list_showroom_id = list.list;
      this.list_showroom_id_all = list.list;
      this.map_showroom_id_all = list.map_list;
    },
    async Search_showroom(search, loading) {
      console.log(loading);
      if (search !== "" && search !== null) {
        var where_key = {
          deleted: {_eq: false},
        };
        if (!this.$commonFuction.isEmpty(search)) {
          where_key.name = {
            _iregex: this.$commonFuction.search(search),
          };
        }
        var list = await this.$CoreService.getLisShowroom(where_key);
        this.list_showroom_id = list.list;
        //console.log("this.listProperty:",this.listProperty)
      } else {
        // cosnole.log("dasdasd")
        this.list_showroom_id = this.list_showroom_id_all;
      }
    },
    //list_available_for_rent
    async change_list_available_for_rent() {
      //   this.obj_data.state_id =null;
      //   this.getListVehicleCategory(this.obj_data.rent_car_for_rent_id);
      // //  this.key_form++;
      //   this.key_vehicle_category++;
      if (this.$commonFuction.isEmpty(this.obj_data.rent_vehicle_category_id)) {
        var item_car =
            this.map_available_for_rent_all[this.obj_data.rent_available_id];
        this.obj_data.rent_vehicle_category_id = item_car.vehicle_category_id;
        this.getListTerm(this.obj_data.rent_vehicle_category_id);
      }
    },
    async getList_available_for_rent() {
      var where_key = {
        deleted: {_eq: false},
        // booking: {id: {_is_null: true} },
      };
      var list = await this.$CoreService.getListAvailableForRent(where_key);
      this.list_available_for_rent = list.list;
      this.list_available_for_rent_all = list.list;
      this.map_available_for_rent_all = list.map_list;
    },
    async Search_available_for_rent(search, loading) {
      console.log(loading);
      if (search !== "" && search !== null) {
        var where_key = {
          deleted: {_eq: false},
        };
        if (!this.$commonFuction.isEmpty(search)) {
          where_key.code = {
            _iregex: this.$commonFuction.search(search),
          };
        }
        var list = await this.$CoreService.getListAvailableForRent(where_key);
        this.list_available_for_rent = list.list;
        //console.log("this.listProperty:",this.listProperty)
      } else {
        // cosnole.log("dasdasd")
        this.list_available_for_rent = this.list_available_for_rent_all;
      }
    },

    async changeCountry() {
      this.obj_data.state_id = null;
      this.getListState(this.obj_data.country_id);
      //  this.key_form++;
      this.key_state++;
    },
    async getListCountry() {
      var where_key = {
        deleted: {_eq: false},
        // booking: {id: {_is_null: true} },
      };
      var list = await this.$CoreService.getListCountry(where_key);
      this.listCountry = list.list;
      this.listCountryAll = list.list;
      this.mapCountryAll = list.map_list;
    },
    async SearchCountry(search, loading) {
      console.log(loading);
      if (search !== "" && search !== null) {
        var where_key = {
          deleted: {_eq: false},
        };
        if (!this.$commonFuction.isEmpty(search)) {
          where_key.name = {
            _iregex: this.$commonFuction.search(search),
          };
        }
        var list = await this.$CoreService.getListCountry(where_key);
        this.listCountry = list.list;
        //console.log("this.listProperty:",this.listProperty)
      } else {
        // cosnole.log("dasdasd")
        this.listCountry = this.listCountryAll;
      }
    },
    async getListState(country_id = null) {
      var where_key = {
        deleted: {_eq: false},
        // booking: {id: {_is_null: true} },
      };
      if (!this.$commonFuction.isEmpty(country_id)) {
        where_key["country_id"] = {_eq: country_id};
      }
      var list = await this.$CoreService.getListState(where_key);
      this.listState = list.list;
      this.listStateAll = list.list;
    },
    async SearchState(search, loading) {
      console.log(loading);
      if (search !== "" && search !== null) {
        var where_key = {
          deleted: {_eq: false},
        };
        if (!this.$commonFuction.isEmpty(this.model.country_id)) {
          where_key["country_id"] = {_eq: this.model.country_id};
        }
        if (!this.$commonFuction.isEmpty(search)) {
          where_key.name = {
            _iregex: this.$commonFuction.search(search),
          };
        }
        var list = await this.$CoreService.getListState(where_key);
        this.listState = list.list;
        //console.log("this.listProperty:",this.listProperty)
      } else {
        // cosnole.log("dasdasd")
        this.listState = this.listStateAll;
      }
    },
    switchVisibility(event, type = null) {
      console.log("event:", event);
      console.log("typetype:", type);
      if (type == "re") {
        this.passwordReType =
            this.passwordReType === "password" ? "text" : "password";
      } else {
        this.passwordType =
            this.passwordType === "password" ? "text" : "password";
      }
    },
    async deleteData() {
      this.showDeleteDialog = false;
      var list_data = [];
      for (let i = 0; i < this.listDataUserFamily.length; i++) {
        var item_data = this.listDataUserFamily[i];
        if (this.deleteId != item_data.id) {
          list_data.push(item_data);
        }
      }
      this.listDataUserFamily = list_data;
      this.loadTableUserFamily();
    },
    async loadTableUserFamily() {
      var stt = 0;
      var listDataUserFamily = this.listDataUserFamily;
      //this.mapServicePriceProduct = {};
      for (let i = 0; i < listDataUserFamily.length; i++) {
        stt++;
        //var itemData = listDataUserFamily[i];
        //var id = itemData?.id ?? null;
        listDataUserFamily[i].stt = stt;
        listDataUserFamily[i].index = i;
        // this.mapServicePriceProduct[id] = itemData;
      }
      this.listDataUserFamily = listDataUserFamily;
      // console.log(" this.listDataUserFamily:", this.listDataUserFamily)
      this.dataModelUserFamily = DataServices.getModel("user_family");
      //this.dataModelProduct.processData(listDataUserFamily)
      this.componentKeyUserFamily++;
    },
    async validateDataUserFamily() {
      if (this.$commonFuction.isEmpty(this.dataFamily.name)) {
        alert("Please enter Fullname");
        return true;
      }
      if (
          !this.$commonFuction.isEmpty(this.dataFamily.prefix_phone) ||
          !this.$commonFuction.isEmpty(this.dataFamily.phone)
      ) {
        if (
            this.$commonFuction.isEmpty(this.dataFamily.prefix_phone) ||
            this.$commonFuction.isEmpty(this.dataFamily.phone)
        ) {
          alert("Please enter Phone number");
          return true;
        }
      }
      if (!this.$commonFuction.isEmpty(this.dataFamily.email)) {
        if (!(await this.$commonFuction.IsEmail(this.dataFamily.email))) {
          alert("Email is not in correct format!");
          return true;
        }
      }

      if (this.list_file_product.length > 0) {
        if (this.list_file_product.length != 2) {
          alert("Please choose 2 photos!");
          return true;
        }
      }
    },
    async saveDataUserFamily() {
      var that = this;
      if (await this.validateDataUserFamily()) {
        return;
      }
      this.$commonFuction.is_loading(true);
      //console.log("this.from_to", this.from_to);
      //console.log("partArr", this.dataBookingRound);
      var params = this.dataFamily;
      //delete this.dataFamilyDisplay
      console.log("paramsparams:", params);
      var id = params?.id ?? null;
      var itemObject = {
        // stt:1,
        list_id_file_delete_product: this.list_id_file_delete_product,
        //avatar:this.list_file_product[0].objectURL,
        list_file_product: this.list_file_product,
        image_list: this.list_file_product,
        name: params?.name ?? null,
        email: params?.email ?? null,
        personal_id: params?.personal_id ?? null,
        relationship: params?.relationship ?? null,
        phone: params?.phone ?? null,
        prefix_phone: params?.prefix_phone ?? null,
        phone_txt: null,
      };
      if (
          !this.$commonFuction.isEmpty(params.phone) &&
          !this.$commonFuction.isEmpty(params.prefix_phone)
      ) {
        itemObject.phone_txt = params.prefix_phone + params.phone;
      }

      if (!this.$commonFuction.isEmpty(id)) {
        itemObject["id"] = id;
        this.listDataUserFamily[params?.index] = itemObject;
      } else {
        itemObject["id"] = moment().valueOf() + "";
        itemObject["is_new"] = 1; //sp này do thêm mới chứ ko từ edit dat trong db
        this.listDataUserFamily.push(itemObject);
      }
      console.log("itemObjectitemObject:", itemObject);

      this.loadTableUserFamily();

      setTimeout(function () {
        //Gọi API refeshtoken
        that.dataFamilyDisplay = false;
        that.$commonFuction.is_loading(false);
        that.clearSaveUserFamily();
      }, 1000);

      /*params["list_file"] = this.list_file
      params["list_type"] = this.listDataUserFamily
      params["list_madatory"] = this.listDataMadatory
      params["list_lang"] = this.listLang
      params["list_id_file_delete"] = this.list_id_file_delete
      console.log('saveData', params)
      this.$emit('save', params)*/
    },
    clearSaveUserFamily() {
      this.dataFamily.id = null;
      this.dataFamily.name = "";
      this.dataFamily.relationship = "";
      this.dataFamily.prefix_phone = "";
      this.dataFamily.phone = "";
      this.dataFamily.email = "";
      this.dataFamily.personal_id = "";
      this.list_file_product = [];
      this.list_id_file_delete_product = [];
    },
    async onActionClicked(payload) {
      var action = payload.action;
      var data = null;
      if (payload.data) {
        data = payload.data;
      }
      var pageTransaction = new Date().getTime();
      console.log("action.nameaction.name:", action.name);
      switch (action.name) {
        case "view":
          this.dialogMode = action.name;
          if (action.path !== undefined && action.path) {
            this.$router.push({path: action.path + data.data[action.key]});
          } else {
            this.editId = data.data[action.key];
            this.displayDialog = true;
            this.editDialogKey++;
          }
          break;
        case "edit":
          //console.log("datadatadata:",data)
          /*this.dialogMode = action.name
          if (action.path !== undefined && action.path) {
            console.log("payload.lazyParams:111"+pageTransaction,payload.lazyParams);
            localStorage.setItem(pageTransaction.toString(), JSON.stringify(payload.lazyParams));
            this.$router.push({ path: action.path + data.data[action.key],query: { page_transaction: pageTransaction.toString() }  })
          } else  {
            this.editId = data.data[action.key]
            this.displayDialog = true
            this.editDialogKey++
          }*/ /*
          this.index_edit =data.data.index
          this.obj_data.type_id =data.data.id
          this.obj_data.price_select =data.data.price_key
          this.key_type_id++;

          this.dataFamilyDisplay = true*/
          console.log("data.datadata.data:", data.data);

          this.list_file_product = data.data?.list_file_product ?? [];
          this.list_id_file_delete_product =
              data.data?.list_id_file_delete_product ?? [];
          /*if (this.list_file_product.length > 0){
            delete data.data.list_file_product;
            delete data.data.image_list;
          }
          console.log("data.datadata.data11:",data.data)
          this.dataFamily = this.$commonFuction.convertJsonObject(data.data)*/
          /* this.dataFamily = data.data
          if (this.list_file_product.length > 0){
            delete this.dataFamily.list_file_product;
            delete this.dataFamily.image_list;
          }*/
          this.dataFamily = {};

          var key_not = ["list_file_product", "image_list"];
          var data_edit = data.data;
          for (let key in data_edit) {
            // if (data_edit.hasOwnProperty(key)) {
            // if (data_edit.hasOwnProperty(key)) { // Check if the property is directly on the object
            // console.log(key + ': ' + person[key]);
            if (key_not.indexOf(key) == -1) {
              this.dataFamily[key] = data_edit[key];
              //  }
            }
          }

          /*this.dataFamily.list_file_product =this.list_file_product;
          this.dataFamily.image_list =this.list_file_product;*/
          //this.dataFamily.list_id_file_delete_product =  this.list_id_file_delete_product;
          this.dataFamilyDisplay = true;
          this.componentDataFamily++;
          break;
        case "delete":
          localStorage.setItem(
              pageTransaction.toString(),
              JSON.stringify(payload.lazyParams)
          );
          this.page_transaction = pageTransaction;
          this.deleteId = data.data[action.key];
          console.log("this.deleteId:", this.deleteId);
          this.deleteName = data.data.name;
          this.showDeleteDialog = true;
          break;
        case "add":
          this.dataFamilyDisplay = true;
          this.componentDataFamily++;
          console.log("this.componentDataFamily:", this.componentDataFamily);
          /*
          this.dialogMode = action.name
          if (action.path !== undefined && action.path) {
            this.$router.push({ path: action.path })
          } else  {
            this.displayDialog = true
            this.editDialogKey++
          }*/
          break;
        case "custom":
          await action.handler(data.data, this);
          this.componentKey++;
          break;
      }
    },
    getRowActions() {
      var actions = {};
      var that = this;
      //if (this.role.add) {
      actions.header = {
        name: "add",
        icon: "plus",
        path: `list-${this.modelName}/add`,
      };
      //}
      // actions.header = { name: 'add', icon: 'plus'};
      actions.rows = function (rowData) {
        var buttons = {};
        //buttons.view = { name: 'view', icon: 'eye', key: 'id', path: `list-${that.modelName}/view/`};
        //if (that.role.edit) {
        buttons.edit = {
          name: "edit",
          icon: "pencil",
          key: "id",
          path: `list-${that.modelName}/edit/`,
        };
        //}
        // buttons.edit = { name: 'edit', icon: 'pencil', key: 'id', path: `${that.modelName}/edit/`}
        //if (that.role.delete) {
        buttons.delete = {name: "delete", icon: "trash", key: "id"};
        //}
        if (that.dataModelUserFamily.actions) {
          var modelaction = that.dataModelUserFamily.actions(rowData);
          Object.assign(buttons, modelaction);
        }
        return buttons;
      };
      return actions;
    },
    onFileClearProduct(item, index) {
      console.log("itemitem:", item);
      var type = item?.type ?? null;
      if (type == "old_edit") {
        this.list_id_file_delete_product.push(item.id);
      }
      this.list_file_product.splice(index, 1);
    },
    async onFileSelectFileProduct(event) {
      var that = this;
      let files = event.target.files || event.dataTransfer.files;
      console.log("filesfiles:", files);
      console.log("files.length:", files.length);
      if (files.length > 0) {
        let acceptTags = [
          "jpeg",
          "jpg",
          "gif",
          "png",
          "JPEG",
          "JPG",
          "PNG",
          "GIF",
          "svg",
          "SVG",
        ];
        console.log("files.length1111111:", files.length);
        for (let i = 0; i < files.length; i++) {
          console.log("files.333333333333:", files.length);
          if (!acceptTags.includes(files[i].name.split(".").pop())) {
            alert("Only post formats are supported: jpeg, jpg, gif, png, svg");
            return;
          }
          //  document.getElementById('file_name').innerText = files[i].name;
          console.log("files[i].namefiles[i].name:", files[i].name);
          that.obj_data.filename = files[i].name;
          this.comFilename++;
        }
        var arrTemp = [],
            arrFiles = [];
        for (let file of files) {
          console.log("file.sizefile.sizefile.size:", file.size);
          if (file.size <= this.maxFileSize) {
            file.source = file;
            file.objectURL = window.URL.createObjectURL(file);
            console.log("asdasdasfile:", file);
            arrTemp.push(file);
          }
          if (file.size > this.maxFileSize) arrFiles.push(file);
        }
        if (arrFiles.length > 0) {
          alert("Your image is larger 100MB");
          that.obj_data.filename = "";
          return;
        } else {
          // if (this.icon_service.length > 0 && this.icon_service[0].file === '') {
          //   this.imagesDeletes.push(this.icon_service[0])
          // }
          console.log("arrTemparrTemp:", arrTemp);
          //this.list_file_product = [];
          this.list_file_product = this.list_file_product.concat.apply(
              this.list_file_product,
              arrTemp
          );
        }
      }
      this.$refs.fileInputProduct.value = null;
    },
    onFileClear(item, index) {
      console.log("itemitem:", item);
      var type = item?.type ?? null;
      if (type == "old_edit") {
        this.list_id_file_delete.push(item.id);
      }
      this.list_file.splice(index, 1);
    },
    async onFileSelectFileAfter(event) {
      var that = this;
      let files = event.target.files || event.dataTransfer.files;
      console.log("filesfiles:", files);
      console.log("files.length:", files.length);
      if (files.length > 0) {
        let acceptTags = [
          "jpeg",
          "jpg",
          "gif",
          "png",
          "JPEG",
          "JPG",
          "PNG",
          "GIF",
          "svg",
          "SVG",
        ];
        console.log("files.length1111111:", files.length);
        for (let i = 0; i < files.length; i++) {
          console.log("files.333333333333:", files.length);
          if (!acceptTags.includes(files[i].name.split(".").pop())) {
            alert("Only post formats are supported: jpeg, jpg, gif, png, svg");
            return;
          }
          //  document.getElementById('file_name').innerText = files[i].name;
          console.log("files[i].namefiles[i].name:", files[i].name);
          that.obj_data.filename = files[i].name;
          this.comFilenameAfter++;
        }
        var arrTemp = [],
            arrFiles = [];
        for (let file of files) {
          console.log("file.sizefile.sizefile.size:", file.size);
          if (file.size <= this.maxFileSize) {
            file.source = file;
            file.objectURL = window.URL.createObjectURL(file);
            console.log("asdasdasfile:", file);
            arrTemp.push(file);
          }
          if (file.size > this.maxFileSize) arrFiles.push(file);
        }
        if (arrFiles.length > 0) {
          alert("Your image is larger 100MB");
          that.obj_data.filename = "";
          return;
        } else {
          // if (this.icon_service.length > 0 && this.icon_service[0].file === '') {
          //   this.imagesDeletes.push(this.icon_service[0])
          // }
          console.log("arrTemparrTemp:", arrTemp);
          this.list_file_after = [];
          this.list_file_after = this.list_file_after.concat.apply(
              this.list_file_after,
              arrTemp
          );
        }
      }
      this.$refs.fileInputAfter.value = null;
    },
    async onFileClearAfter(item, index) {
      console.log("itemitem:", item);
      var type = item?.type ?? null;
      if (type == "old_edit") {
        this.list_id_file_delete_after.push(item.id);
      }
      this.list_file_after.splice(index, 1);
    },
    async onFileSelectFile(event) {
      var that = this;
      let files = event.target.files || event.dataTransfer.files;
      console.log("filesfiles:", files);
      console.log("files.length:", files.length);
      if (files.length > 0) {
        let acceptTags = [
          "jpeg",
          "jpg",
          "gif",
          "png",
          "JPEG",
          "JPG",
          "PNG",
          "GIF",
          "svg",
          "SVG",
        ];
        console.log("files.length1111111:", files.length);
        for (let i = 0; i < files.length; i++) {
          console.log("files.333333333333:", files.length);
          if (!acceptTags.includes(files[i].name.split(".").pop())) {
            alert("Only post formats are supported: jpeg, jpg, gif, png, svg");
            return;
          }
          //  document.getElementById('file_name').innerText = files[i].name;
          console.log("files[i].namefiles[i].name:", files[i].name);
          that.obj_data.filename = files[i].name;
          this.comFilename++;
        }
        var arrTemp = [],
            arrFiles = [];
        for (let file of files) {
          console.log("file.sizefile.sizefile.size:", file.size);
          if (file.size <= this.maxFileSize) {
            file.source = file;
            file.objectURL = window.URL.createObjectURL(file);
            console.log("asdasdasfile:", file);
            arrTemp.push(file);
          }
          if (file.size > this.maxFileSize) arrFiles.push(file);
        }
        if (arrFiles.length > 0) {
          alert("Your image is larger 100MB");
          that.obj_data.filename = "";
          return;
        } else {
          // if (this.icon_service.length > 0 && this.icon_service[0].file === '') {
          //   this.imagesDeletes.push(this.icon_service[0])
          // }
          console.log("arrTemparrTemp:", arrTemp);
          this.list_file = [];
          this.list_file = this.list_file.concat.apply(this.list_file, arrTemp);
        }
      }
    },
    isImage(file) {
      return /^image\//.test(file.type);
    },
    updateMatrix(data) {
      console.log(data);
      this.dataBookingRound = [...data];
      // this.componentKey++;
    },
    async toCalendar() {
      this.$router.push(
          `/admin/list-booking?view=calendar&propery_id=${this.selProperty?.id}`
      );
    },
    async getListProperty() {
      var where_key = {
        deleted: {_eq: false},
        // booking: {id: {_is_null: true} },
      };
      var list = await this.$CoreService.getListProperty(where_key);
      this.listProperty = list.list;
      this.listPropertyAll = list.list;
    },

    async SearchProperty(search, loading) {
      console.log(loading);
      if (search !== "" && search !== null) {
        var where_key = {
          deleted: {_eq: false},
        };
        if (!this.$commonFuction.isEmpty(search)) {
          where_key.name = {
            _iregex: this.$commonFuction.search(search),
          };
        }
        var list = await this.$CoreService.getListProperty(where_key);
        this.listProperty = list.list;
        //console.log("this.listProperty:",this.listProperty)
      } else {
        // cosnole.log("dasdasd")
        this.listProperty = this.listPropertyAll;
      }
    },

    async getListDocsCate() {
      var where_key = {
        deleted: {_eq: false},
        // booking: {id: {_is_null: true} },
      };
      var list = await this.$CoreService.getListDocsCate(where_key);
      this.listDocsCate = list.list;
      this.listDocsCateAll = list.list;
    },

    async SearchDocsCate(search, loading) {
      console.log(loading);
      if (search !== "" && search !== null) {
        var where_key = {
          deleted: {_eq: false},
        };
        if (!this.$commonFuction.isEmpty(search)) {
          where_key.name = {
            _iregex: this.$commonFuction.search(search),
          };
        }
        var list = await this.$CoreService.getListDocsCate(where_key);
        this.listDocsCate = list.list;
        //console.log("this.listProperty:",this.listProperty)
      } else {
        // cosnole.log("dasdasd")
        this.listDocsCate = this.listDocsCateAll;
      }
    },

    backToList() {
      this.$emit("back");
    },
    validatePhoneNumber(phone) {
      // Biểu thức chính quy cho số điện thoại có thể có hoặc không có dấu +, không có dấu (), và -
      const phoneRegex = /^\+?[0-9\s]{7,15}$/;
      return phoneRegex.test(phone);
    },
    async validateData() {
      this.validationErrors = {};
      let tmp_booking_status = document.getElementById("tmp_booking_status");
      if (this.$commonFuction.isEmpty(this.obj_data.booking_status)) {
        tmp_booking_status.setCustomValidity(
            this.$constants.MSG_TEXT.SELECT_INVALID_MSG
        );
      } else {
        tmp_booking_status.setCustomValidity("");
      }
      //validate các field required vd vehicle category
      let tmp_rent_vehicle_category_id = document.getElementById(
          "tmp_rent_vehicle_category_id"
      );
      if (this.$commonFuction.isEmpty(this.obj_data.rent_vehicle_category_id)) {
        tmp_rent_vehicle_category_id.setCustomValidity(
            this.$constants.MSG_TEXT.SELECT_INVALID_MSG
        );
      } else {
        tmp_rent_vehicle_category_id.setCustomValidity("");
      }
      let tmp_rent_term_id = document.getElementById("tmp_rent_term_id");
      if (this.$commonFuction.isEmpty(this.obj_data.rent_term_id)) {
        tmp_rent_term_id.setCustomValidity(
            this.$constants.MSG_TEXT.SELECT_INVALID_MSG
        );
      } else {
        tmp_rent_term_id.setCustomValidity("");
      }
      // let tmp_rent_car_for_rent_id = document.getElementById("tmp_rent_car_for_rent_id");
      // if (this.$commonFuction.isEmpty(this.obj_data.rent_car_for_rent_id)){
      //   tmp_rent_car_for_rent_id.setCustomValidity(this.$constants.MSG_TEXT.SELECT_INVALID_MSG);
      // }else {
      //   tmp_rent_car_for_rent_id.setCustomValidity("");
      // }
      let tmp_showroom_id = document.getElementById("tmp_showroom_id");
      if (this.$commonFuction.isEmpty(this.obj_data.showroom_id)) {
        tmp_showroom_id.setCustomValidity(
            this.$constants.MSG_TEXT.SELECT_INVALID_MSG
        );
      } else {
        tmp_showroom_id.setCustomValidity("");
      }
      //renter
      var tmp_rent_pick_up_date = document.getElementById(
          "tmp_rent_pick_up_date"
      );
      var text_validate_pick_up_date ='';
      if (this.$commonFuction.isEmpty(this.obj_data.rent_pick_up_date)) {
        text_validate_pick_up_date = this.$constants.MSG_TEXT.INPUT_INVALID_MSG
      } else {
        //check ngày bị sai format
        console.log("this.obj_data.rent_pick_up_date",this.obj_data.rent_pick_up_date)
        if (moment(this.obj_data.rent_pick_up_date).isValid() == false) {
          text_validate_pick_up_date = "Date is not in correct format!";
        } 
      }
      var tmp_rent_valid_until = document.getElementById(
          "tmp_rent_valid_until"
      );
      if (this.$commonFuction.isEmpty(this.obj_data.rent_valid_until)) {
        tmp_rent_valid_until.setCustomValidity(
            this.$constants.MSG_TEXT.INPUT_INVALID_MSG
        );
      } else {
if (moment(this.obj_data.rent_pick_up_date).isValid() == false) {
          tmp_rent_pick_up_date.setCustomValidity(
              "Date is not in correct format!"
          );
        } else {
          tmp_rent_pick_up_date.setCustomValidity("");
        }
      }
      //check ngày Valid until ko nhỏ hơn Pick-up date
      if (
          !this.$commonFuction.isEmpty(this.obj_data.rent_pick_up_date) &&
          !this.$commonFuction.isEmpty(this.obj_data.rent_valid_until)
      ) {
        if (
            moment(this.obj_data.rent_valid_until).isBefore(
                this.obj_data.rent_pick_up_date
            )
        ) {
          text_validate_pick_up_date = "Valid until must be greater than Pick-up date!";
        } 
      } 

      if(!this.$commonFuction.isEmpty(text_validate_pick_up_date)){
        tmp_rent_pick_up_date.setCustomValidity(text_validate_pick_up_date);
        }else{
        tmp_rent_pick_up_date.setCustomValidity("");
        }

      var tmp_uid = document.getElementById("tmp_uid");
      if (this.$commonFuction.isEmpty(this.obj_data.uid)) {
        tmp_uid.setCustomValidity(this.$constants.MSG_TEXT.SELECT_INVALID_MSG);
      } else {
        tmp_uid.setCustomValidity("");
      }
      var rent_contact_name = document.getElementById("rent_contact_name");
      if (this.$commonFuction.isEmpty(this.obj_data.rent_contact_name)) {
        rent_contact_name.setCustomValidity(
            this.$constants.MSG_TEXT.INPUT_INVALID_MSG
        );
      } else {
        rent_contact_name.setCustomValidity("");
      }
      var rent_contact_phone = document.getElementById("rent_contact_phone");
      var txt_phone = "";
      if (this.$commonFuction.isEmpty(this.obj_data.rent_contact_phone)) {
        txt_phone = this.$constants.MSG_TEXT.INPUT_INVALID_MSG;
        //rent_contact_phone.setCustomValidity(this.$constants.MSG_TEXT.INPUT_INVALID_MSG);
      } else {
        if (this.obj_data.rent_contact_phone.length < 8) {
          txt_phone = "Please enter a phone number of at least 8 characters!";
          //phone.setCustomValidity("Please enter a phone number of at least 8 characters!");
        } else {
          if (
              !this.$commonFuction.validatePhoneNumber(
                  this.obj_data.rent_contact_phone
              )
          ) {
            txt_phone = "Invalid phone number";
          }
          //kiểm tra
          //phone.setCustomValidity("");
        }
      }
      if (!this.$commonFuction.isEmpty(txt_phone)) {
        rent_contact_phone.setCustomValidity(txt_phone);
      } else {
        rent_contact_phone.setCustomValidity("");
      }

      var rent_contact_email = document.getElementById("rent_contact_email");
      if (this.$commonFuction.isEmpty(this.obj_data.rent_contact_email)) {
        rent_contact_email.setCustomValidity(
            this.$constants.MSG_TEXT.INPUT_INVALID_MSG
        );
      } else {
        if (
            await this.$commonFuction.IsEmail(this.obj_data.rent_contact_email)
        ) {
          rent_contact_email.setCustomValidity("");
        } else {
          rent_contact_email.setCustomValidity(
              "Email is not in correct format!"
          );
        }
      }


      // ===== REQUIRED: Address =====
      var rent_contact_address = document.getElementById("rent_contact_address");
      if (this.$commonFuction.isEmpty(this.obj_data.rent_contact_address)) {
        rent_contact_address.setCustomValidity(this.$constants.MSG_TEXT.INPUT_INVALID_MSG);
      } else {
        rent_contact_address.setCustomValidity("");
      }

      // ===== REQUIRED: License No. =====
      var rent_license_no = document.getElementById("rent_license_no");
      if (this.$commonFuction.isEmpty(this.obj_data.rent_license_no)) {
        rent_license_no.setCustomValidity(this.$constants.MSG_TEXT.INPUT_INVALID_MSG);
      } else {
        rent_license_no.setCustomValidity("");
      }

      // ===== REQUIRED + VALIDATE DATE: License Expiry Date (DD/MM/YYYY) =====
      var rent_license_expiry_date = document.getElementById("rent_license_expiry_date");
      let text_license_expiry = "";

      if (this.$commonFuction.isEmpty(this.obj_data.rent_license_expiry_date)) {
        text_license_expiry = this.$constants.MSG_TEXT.INPUT_INVALID_MSG;
      } else {
        // strict parse đúng format DD/MM/YYYY và kiểm tra ngày hợp lệ (vd 31/02/2025 sẽ fail)
        if (moment(this.obj_data.rent_license_expiry_date, "DD/MM/YYYY", true).isValid() === false) {
          text_license_expiry = "Date is not in correct format! (DD/MM/YYYY)";
        }
      }

      if (!this.$commonFuction.isEmpty(text_license_expiry)) {
        rent_license_expiry_date.setCustomValidity(text_license_expiry);
      } else {
        rent_license_expiry_date.setCustomValidity("");
      }


      var tmp_rent_identification_information = document.getElementById(
          "tmp_rent_identification_information"
      );
      if (
          this.$commonFuction.isEmpty(
              this.obj_data.rent_identification_information
          )
      ) {
        tmp_rent_identification_information.setCustomValidity(
            this.$constants.MSG_TEXT.SELECT_INVALID_MSG
        );
      } else {
        tmp_rent_identification_information.setCustomValidity("");
      }
      var rent_number_id = document.getElementById("rent_number_id");
      if (this.$commonFuction.isEmpty(this.obj_data.rent_number_id)) {
        rent_number_id.setCustomValidity(
            this.$constants.MSG_TEXT.INPUT_INVALID_MSG
        );
      } else {
        rent_number_id.setCustomValidity("");
      }
      var rent_pay_price_per_week = document.getElementById(
          "rent_pay_price_per_week"
      );
      var text_rent_pay_price_per_week =this.$commonFuction.coreValidateNumberDecimalPositive(this.obj_data.rent_pay_price_per_week);
      if(!this.$commonFuction.isEmpty(text_rent_pay_price_per_week)){
        rent_pay_price_per_week.setCustomValidity(text_rent_pay_price_per_week);
      }else{
        rent_pay_price_per_week.setCustomValidity("");
      }


      var rent_pay_bond_fee = document.getElementById("rent_pay_bond_fee");
      var text_rent_pay_bond_fee =this.$commonFuction.coreValidateNumberDecimalPositive(this.obj_data.rent_pay_bond_fee);
      if(!this.$commonFuction.isEmpty(text_rent_pay_bond_fee)){
        rent_pay_bond_fee.setCustomValidity(text_rent_pay_bond_fee);
      }else{
        rent_pay_bond_fee.setCustomValidity("");
      }
      var rent_late_fee_threshold = document.getElementById(
          "rent_late_fee_threshold"
      );
      var text_rent_late_fee_threshold =this.$commonFuction.coreValidateNumberDecimalPositive(this.obj_data.rent_late_fee_threshold);
      if(!this.$commonFuction.isEmpty(text_rent_late_fee_threshold)){
        rent_late_fee_threshold.setCustomValidity(text_rent_late_fee_threshold);
      }else{
        rent_late_fee_threshold.setCustomValidity("");
      }
      
      var rent_late_fee_per_day = document.getElementById(
          "rent_late_fee_per_day"
      );
      var text_rent_late_fee_per_day =this.$commonFuction.coreValidateNumberDecimalPositive(this.obj_data.rent_late_fee_per_day);
      if(!this.$commonFuction.isEmpty(text_rent_late_fee_per_day)){
        rent_late_fee_per_day.setCustomValidity(text_rent_late_fee_per_day);
      }else{
        rent_late_fee_per_day.setCustomValidity("");
      }

      var rent_booking_fee = document.getElementById("rent_booking_fee");
      var text_rent_booking_fee =this.$commonFuction.coreValidateNumberDecimalPositive(this.obj_data.rent_booking_fee);
      if(!this.$commonFuction.isEmpty(text_rent_booking_fee)){
        rent_booking_fee.setCustomValidity(text_rent_booking_fee);
      }else{
        rent_booking_fee.setCustomValidity("");
      }

      var inpObj = document.getElementById("frm_action");
      if (!inpObj.checkValidity()) {
        console.log("test=====================");
        inpObj.reportValidity();
        return true;
      }
    },
    async checkEmail(email) {
      // if(this.email !== null && this.email !== ''){
      var where = {
        email: {_eq: email},
        deleted: {_eq: false},
        // type: {'_eq' : 'user'}
      };
      if (this.model !== undefined)
        where = Object.assign(where, {id: {_neq: this.model.id}});
      var {data} = await this.$apollo.query({
        query: DataServices.getList("users", {fields: "id, email"}),
        variables: {
          where_key: where,
        },
        fetchPolicy: "network-only",
      });
      // console.log(data)
      return data && data[Object.keys(data)].length > 0;
      //}
    },
    async saveData() {
      this.$commonFuction.is_loading(true);
      if (await this.validateData()) {
        this.$commonFuction.is_loading(false);
        return;
      }
      if(this.mode == 'add'){
        if(this.obj_data.is_pay_booking_fee != true){
        alert("Please tick the check box Booking fee paid to create the order");
         this.$commonFuction.is_loading(false);
        return;
        }
      }
      //console.log("this.from_to", this.from_to);
      //console.log("partArr", this.dataBookingRound);
      var params = this.obj_data;
      //params["list_product"] = this.listDataProduct
      params["list_id_file_delete"] = this.list_id_file_delete;
      params["list_file"] = this.list_file;
      params["list_file_after"] = this.list_file_after;
      params["list_id_file_delete_after"] = this.list_id_file_delete_after;
      //params["list_user_family"] = this.listDataUserFamily
      console.log("saveData", params);
      this.$emit("save", params);
    },
  },
};
</script>

<style lang="scss">
.p-multiselect {
  width: 450px;
}

.p-multiselect-label:not(.p-placeholder) {
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
}

.category-item-value {
  padding: 0.25rem 0.5rem;
  border-radius: 3px;
  display: inline-flex;
  margin-right: 0.2rem;
  background-color: var(--primary-color);
  color: var(--primary-color-text);
}

.p-multiselect-label-container {
  height: 40px;
}

.p-inputtext {
  margin: 0px 0px 0px 4px;
}

//style form add-edit
@media screen and (min-width: 1001px) {
  .input_distance {
    width: 728px !important;
  }
}

label.p-col-fixed txt-right {
  margin-bottom: 0px !important;
}

div.p-card-field {
  padding: 0px !important;
}

.p-col-fixed {
  padding: 0px !important;
  margin: 0px 0px 0px 9px !important;
}

.input_text {
  width: 760px !important;
  height: 48px !important;
}

.multiselect {
  width: 760px !important;
}



.vs__clear {
  display: none;
}

.input_width {
  width: 760px !important;
  height: 48px !important;
}

#distance {
  width: 1px !important;
  height: 48px !important;
  border-left: 0px;
  border-top: 0px;
  border: 1px solid #c8c8c8;
  border-radius: 0px;
  //border-top: none!important;
  //border: 1px solid rgba(60, 60, 60, 0.26);;
}

.manager-title {
  font-size: 24px !important;
}

.input-dif {
  margin-left: 5px !important;
  border-top: 0px;
}

.p-inputgroup-addon {
  height: 48px;
}

.p-col-fixed {
  padding: 0px !important;
  //margin:0px 0px 0px 10px !important;
}

label.p-col-fixed txt-right {
  margin-bottom: 0px !important;
}

div.p-card-field {
  padding: 0px !important;
}

.margin {
  margin-bottom: 12px !important;
}

.border_color {
  border: 1px solid #c8c8c8;
}

.text {
  font-weight: normal !important;
  margin-left: 15px !important;
}

.div_check {
  margin-top: 12px !important;
}

//responsive
@media screen and (max-width: 600px) {
  .input_width {
    width: 100% !important;
  }
  .div-button {
    padding: 8px !important;
  }
  #distance {
    text-align: left !important;
    padding: 6.8px;
    width: 100% !important;
  }
  .p-inputgroup-addon {
    margin-right: 12px;
  }
}

@media screen and (max-width: 1000px) {
  .input_width {
    width: 100% !important;
  }
  .div-button {
    padding: 8px !important;
  }
  .p-inputgroup-addon {
    margin-right: 12px;
  }
  #distance {
    text-align: left !important;
    padding: 6.8px;
  }
}

/*.p-button-outlined {
  .p-button-label {
    color: #007ad9 !important;
  }
}*/
.cus-text {
  margin-left: 2px;
  margin-top: 4px;
}

.style-box-phone {
  border: 1px solid #a6a6a6;
  width: 100%;
  display: flex;

  .p-dropdown {
    width: 100px;
    border: 0px;
    box-shadow: none !important;
  }

  .p-focus {
    border: 0px;
    box-shadow: none;
  }

  .p-dropdown:focus {
    border: 0px;
    box-shadow: none;
  }

  input {
    width: calc(100% - 100px);
    margin-left: 0px;
    border: 0px;
  }

  .p-inputtext:enabled:focus {
    border: 0px;
    box-shadow: none;
  }
}

.style_list_image {
  display: flex;
  flex-wrap: wrap; /* Cho phép các phần tử xuống dòng */
  gap: 10px; /* Khoảng cách giữa các phần tử */
  .box-image {
    width: 100px;
    height: 100px;
    margin-top: 8px;
    margin-bottom: 8px;
    position: relative;

    .style_img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      border: 1px solid #d0d4d9;
      border-radius: 10px;
    }

    .button-clear {
      width: 20px;
      height: 20px;
      position: absolute;
      top: 1px;
      right: 8px;
    }
  }
}

.box-password-style {
  width: 100%;
  position: relative;

  .lg-icon-password {
    margin-top: -30px;
    display: block;
    position: absolute;
    right: 10px;
    padding: auto 5px;

    &:hover {
      cursor: pointer;
    }
  }
}

.style_title_group {
  font: normal normal bold 20px/27px Segoe UI;
  letter-spacing: 0px;
  color: #333333;
  text-transform: uppercase;
  margin-bottom: 8px;
  margin-top: 8px;
}

.gender-options {
  display: flex; // Sử dụng flexbox để căn chỉnh ngang
  gap: 48px; // Khoảng cách giữa các radio button

  label {
    display: flex;
    align-items: center; // Căn giữa theo chiều dọc
    cursor: pointer; // Hiển thị con trỏ khi hover

    input[type="radio"] {
      width: 20px; // Chiều rộng
      height: 20px; // Chiều cao
      margin-right: 5px; // Khoảng cách giữa radio button và nhãn
    }
  }
}

.style_line_password {
  text-align: left;
  font: normal normal normal 16px/21px Segoe UI;
  letter-spacing: 0px;
  color: #666666;
}

.group-button-detail-top {
  display: flex;
  justify-content: flex-end;
  padding-bottom: 16px;
  padding-right: 0px;

  .style-button-common {
    margin-left: 8px;
    margin-right: 8px;
    width: fit-content;
  }

  .style-button-common:last-of-type {
    margin-right: 0px;
  }
}

.clear_icon_select {
  .vs__clear {
    display: unset !important;
  }
}

.car_custom_popup {
  margin-top: -18px;
}

.box-payment {
  background: #F8F8F8 0% 0% no-repeat padding-box;
  border: 1px solid #D0D4D9;
  border-radius: 5px;
  padding: 20px; /* Thêm khoảng cách cho nội dung */

  .payment-item {
    display: flex;
    justify-content: space-between; /* Đẩy title sang trái và price sang phải */
    align-items: flex-start; /* Căn chỉnh theo chiều dọc */
  }

  .title {
    font: normal normal normal 16px/19px Segoe UI;
    letter-spacing: 0px;
    color: #666666;
    word-wrap: break-word; /* Cho phép title bọc dòng nếu nội dung quá dài */
  }

  .price {
    white-space: nowrap; /* Ngăn giá tiền xuống dòng */
    font: normal normal normal 16px/19px Segoe UI;
    letter-spacing: 0px;
    color: #000000;
  }
}

.line_horizontal {
  border: 1px solid #f1f0f0;
  margin-bottom: 10px;
  margin-top: 10px;
}

.custom-textarea {
  width: 100%;
  border-radius: 5px;
  border: 1px solid #c5c5c5;
  padding: 12px;
  font-size: 16px;
  line-height: 1.5;
  color: #333;
  box-sizing: border-box;
  /* Đảm bảo padding không làm thay đổi kích thước tổng thể */
  background-color: #fff;
}

.custom-textarea::placeholder {
  color: #999;
  /* Màu placeholder nhẹ hơn */
  font-style: italic;
}

.style-box-payment {
  margin-left: 9px;
  margin-right: 9px;
  margin-top: 8px;
  margin-bottom: 8px
}

.style-child-other-cost {
  margin-left: 24px;
}

.style-text-box-payment-gray {
  font: normal normal normal 16px/21px Segoe UI;
  letter-spacing: 0px;
  color: #000000;
}

.style-box-rewal {
  margin-left: -7px !important;
}


.class_style_input_a {
            padding: 8px;;height: 41px;width:100%;background: #EEEEEE 0% 0% no-repeat padding-box; border: 1px solid #D0D4D9; border-radius: 5px;
            .style_tag_a{
                text-decoration: underline;
            }
        }
</style>
